import { filter, find, get, includes, keys, map, pickBy, reject } from 'lodash';
import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
import { currencies, newAccountCurrencies } from './general';
import { regulators } from './regulators';
import { mt4Servers, mt5Servers } from './forexServers';
import { countries, regions } from './countries';
import { educationalVideoLevels } from './client';
const disallowedGoldCurrencies = reject(keys(currencies), (k) => k === 'EUR');
export const accountTypes = generateLocalization('accountTypes', generateKeys({
    ForexClassicAccount: {
        company: companies.swissMarkets.value,
        value: 'forex_classic',
        label: 'STP',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicAccount',
        forAccountFilter: 'forForexClassicAccount',
        icon: 'account-type-sm-forex-classic.png',
        productId: 10,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['CLASSIC'],
        server: 'BDSSwissMarkets-Real01',
        supportsCustomLeverage: true,
        leverages: [2, 5, 10, 20, 30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexClassicAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CHF', 'PLN', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    ForexClassicDemoAccount: {
        company: companies.swissMarkets.value,
        value: 'forex_classic_demo',
        label: 'STP Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicDemoAccount',
        forAccountFilter: 'forForexClassicDemoAccount',
        icon: 'account-type-sm-forex-classic-demo.png',
        productId: 11,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        server: 'BDSSwissMarkets-Demo01',
        supportsCustomLeverage: true,
        leverages: [30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexClassicDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CHF', 'PLN', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        openSeperateDemo: true,
        deprecated: false,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    ForexRawAccount: {
        company: companies.swissMarkets.value,
        value: 'forex_raw',
        label: 'STP Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawAccount',
        forAccountFilter: 'forForexRawAccount',
        icon: 'account-type-sm-forex-raw.png',
        productId: 12,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['SWISS11', 'SWISS4'],
        server: 'BDSSwissMarkets-Real01',
        supportsCustomLeverage: true,
        leverages: [2, 5, 10, 20, 30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexRawAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CHF', 'PLN', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    SpotOptionAccount: {
        company: companies.bdSwiss.value,
        value: 'binary',
        label: 'Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionAccount',
        forAccountFilter: 'forSpotOptionAccount',
        icon: 'account-type-bd-spot-option.png',
        productId: 5,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary',
        orderBy: 6,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: false,
        supportsCustomLeverage: false,
        termsConditionsLink: 'binaryTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'SpotOptionAccount',
        hidden: false,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    SpotOptionDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'binary_demo',
        label: 'Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionDemoAccount',
        forAccountFilter: 'forSpotOptionDemoAccount',
        icon: 'account-type-bd-spot-option-demo.png',
        productId: 6,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary_demo',
        orderBy: 7,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        regulator: regulators.cysec,
        baseProduct: 'SpotOptionDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    ForexAccount: {
        company: companies.bdSwiss.value,
        value: 'forex',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexAccount',
        forAccountFilter: 'forForexAccount',
        icon: 'account-type-bd-forex.png',
        productId: 3,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'VivernoMarkets-Real01',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW'],
        termsConditionsLink: 'forexTerms',
        leverages: [2, 5, 10, 20, 30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: false,
    },
    ForexDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'forex_demo',
        label: 'Forex MT4 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexDemoAccount',
        forAccountFilter: 'forForexDemoAccount',
        icon: 'account-type-bd-forex-demo.png',
        productId: 7,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'VivernoMarkets-Demo01',
        leverages: [30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: false,
    },
    PAMMAccount: {
        company: companies.bdSwiss.value,
        value: 'pamm',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMAccount',
        forAccountFilter: 'forPAMMAccount',
        icon: 'account-type-bd-pamm.png',
        productId: 13,
        localization: { defaultMessage: '', id: '' },
        productName: 'pamm',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
    },
    PAMMSMAccount: {
        company: companies.swissMarkets.value,
        value: 'pamm',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMSMAccount',
        forAccountFilter: 'forPAMMSMAccount',
        icon: 'account-type-sm-pamm.png',
        productId: 14,
        localization: { defaultMessage: '', id: '' },
        productName: 'pamm',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMSMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
    },
    CuboidAccount: {
        company: companies.bdSwiss.value,
        value: 'cuboid',
        label: 'Range Spreads',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidAccount',
        forAccountFilter: 'forCuboidAccount',
        icon: 'account-type-bd-cuboid.png',
        productId: 9,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid',
        orderBy: 10,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cuboid',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        hidden: true,
        supportsMultipleAccounts: false,
        regulator: regulators.cysec,
        baseProduct: 'CuboidAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    CuboidDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'cuboid_demo',
        label: 'Range Spreads Demo',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidDemoAccount',
        forAccountFilter: 'forCuboidDemoAccount',
        icon: 'account-type-bd-cuboid-demo.png',
        productId: 8,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid_demo',
        orderBy: 11,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cuboid',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        disabled: false,
        supportsMultipleAccounts: false,
        regulator: regulators.cysec,
        baseProduct: 'CuboidDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    TradesmarterAccount: {
        company: companies.bdSwiss.value,
        value: 'tradesmarter',
        label: 'New Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradesmarterAccount',
        forAccountFilter: 'forTradesmarterAccount',
        icon: 'account-type-bd-tradesmarter.png',
        productId: 15,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter',
        orderBy: 8,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexAccount',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.cysec,
        baseProduct: 'TradesmarterAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    TradesmarterDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'tradesmarter_demo',
        label: 'New Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradeSmarterDemoAccount',
        forAccountFilter: 'forTradeSmarterDemoAccount',
        icon: 'account-type-bd-tradesmarter-demo.png',
        productId: 16,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter_demo',
        orderBy: 9,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexDemoAccount',
        isDemo: true,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.cysec,
        baseProduct: 'TradesmarterDemoAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    PAMMFundManagerAccount: {
        company: companies.bdSwiss.value,
        value: 'pammFundManager',
        label: 'Fund Manager Account',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasPAMMFundManagerAccount',
        forAccountFilter: 'forPAMMFundManagerAccount',
        icon: 'account-type-bd-pamm-fm.png',
        productId: 17,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammFundManager',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    PAMMSMFundManagerAccount: {
        company: companies.swissMarkets.value,
        value: 'pammFundManager',
        label: 'Fund Manager Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMFundManagerAccount',
        forAccountFilter: 'forPAMMFundManagerAccount',
        icon: 'account-type-sm-pamm-fm.png',
        productId: 18,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammFundManager',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMSMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    AffiliateAccount: {
        company: companies.bdSwiss.value,
        value: 'affiliate',
        label: 'Affiliate - Cellxperts',
        shortLabel: 'AFF',
        hasAccountFilter: 'hasAffiliateAccount',
        forAccountFilter: 'forAffiliateAccount',
        icon: 'account-type-bd-cellxpert.png',
        productId: 19,
        localization: { defaultMessage: '', id: '' },
        productName: 'affiliate',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: true,
        category: 'affiliate',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'AffiliateAccount',
        walletProduct: true,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'EUR', 'GBP', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
    },
    SpotOptionMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'binary_mauritius',
        label: 'Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionMauritiusAccount',
        forAccountFilter: 'forSpotOptionMauritiusAccount',
        icon: 'account-type-ma-spot-option.png',
        productId: 20,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary_mauritius',
        orderBy: 6,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: false,
        supportsCustomLeverage: false,
        termsConditionsLink: 'binaryTerms',
        leverages: [],
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'SpotOptionAccount',
        hidden: false,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    SpotOptionMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'binary_mauritius_demo',
        label: 'Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionMauritiusDemoAccount',
        forAccountFilter: 'forSpotOptionMauritiusDemoAccount',
        icon: 'account-type-ma-spot-option-demo.png',
        productId: 21,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary_mauritius_demo',
        orderBy: 7,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'SpotOptionDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    ForexMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_mauritius',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMauritiusAccount',
        forAccountFilter: 'forForexMauritiusAccount',
        icon: 'account-type-ma-forex.png',
        productId: 22,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
    },
    ForexMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_mauritius_demo',
        label: 'Forex MT4 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMauritiusDemoAccount',
        forAccountFilter: 'forForexMauritiusDemoAccount',
        icon: 'account-type-ma-forex-demo.png',
        productId: 23,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    CuboidMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'cuboid_mauritius',
        label: 'Range Spreads',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidMauritiusAccount',
        forAccountFilter: 'forCuboidMauritiusAccount',
        icon: 'account-type-ma-cuboid.png',
        productId: 24,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid_mauritius',
        orderBy: 10,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cuboid',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        hidden: true,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'CuboidAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    CuboidMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'cuboid_mauritius_demo',
        label: 'Range Spreads Demo',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidMauritiusDemoAccount',
        forAccountFilter: 'forCuboidMauritiusDemoAccount',
        icon: 'account-type-ma-cuboid-demo.png',
        productId: 25,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid_mauritius_demo',
        orderBy: 11,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cuboid',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        disabled: false,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'CuboidDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    SpotOptionVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'binary_vanuatu',
        label: 'Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionVanuatuAccount',
        forAccountFilter: 'forSpotOptionVanuatuAccount',
        icon: 'account-type-va-spot-option.png',
        productId: 26,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary_vanuatu',
        orderBy: 6,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: false,
        supportsCustomLeverage: false,
        termsConditionsLink: 'binaryTerms',
        leverages: [],
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'SpotOptionAccount',
        hidden: false,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    SpotOptionVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'binary_vanuatu_demo',
        label: 'Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasSpotOptionVanuatuDemoAccount',
        forAccountFilter: 'forSpotOptionVanuatuDemoAccount',
        icon: 'account-type-va-spot-option-demo.png',
        productId: 27,
        localization: { defaultMessage: '', id: '' },
        productName: 'binary_vanuatu_demo',
        orderBy: 7,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'spotOption',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'SpotOptionDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    ForexVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_vanuatu',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexVanuatuAccount',
        forAccountFilter: 'forForexVanuatuAccount',
        icon: 'account-type-va-forex.png',
        productId: 28,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        disallowedCountryCurrencies: [
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
    },
    ForexVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_vanuatu_demo',
        label: 'Forex MT4 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexVanuatuDemoAccount',
        forAccountFilter: 'forForexVanuatuDemoAccount',
        icon: 'account-type-va-forex-demo.png',
        productId: 29,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        disallowedCountryCurrencies: [
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    CuboidVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'cuboid_vanuatu',
        label: 'Range Spreads',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidVanuatuAccount',
        forAccountFilter: 'forCuboidVanuatuAccount',
        icon: 'account-type-va-cuboid.png',
        productId: 30,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid_vanuatu',
        orderBy: 10,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cuboid',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        hidden: true,
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'CuboidAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    CuboidVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'cuboid_vanuatu_demo',
        label: 'Range Spreads Demo',
        shortLabel: 'CU',
        hasAccountFilter: 'hasCuboidVanuatuDemoAccount',
        forAccountFilter: 'forCuboidVanuatuDemoAccount',
        icon: 'account-type-va-cuboid-demo.png',
        productId: 31,
        localization: { defaultMessage: '', id: '' },
        productName: 'cuboid_vanuatu_demo',
        orderBy: 11,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cuboid',
        isDemo: true,
        supportsCustomLeverage: false,
        leverages: [],
        disabled: false,
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'CuboidDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    TradesmarterMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'tradesmarter_mauritius',
        label: 'New Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradesmarterMauritiusAccount',
        forAccountFilter: 'forTradesmarterMauritiusAccount',
        icon: 'account-type-ma-tradesmarter.png',
        productId: 32,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter_mauritius',
        orderBy: 8,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexMauritiusAccount',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.fsc,
        baseProduct: 'TradesmarterAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    TradesmarterMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'tradesmarter_mauritius_demo',
        label: 'New Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradeSmarterMauritiusDemoAccount',
        forAccountFilter: 'forTradeSmarterMauritiusDemoAccount',
        icon: 'account-type-ma-tradesmarter-demo.png',
        productId: 33,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter_mauritius_demo',
        orderBy: 9,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexMauritiusDemoAccount',
        isDemo: true,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.fsc,
        baseProduct: 'TradesmarterDemoAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    TradesmarterVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'tradesmarter_vanuatu',
        label: 'New Binary Options (Real)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradesmarterVanuatuAccount',
        forAccountFilter: 'forTradesmarterVanuatuAccount',
        icon: 'account-type-va-tradesmarter.png',
        productId: 34,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter_vanuatu',
        orderBy: 8,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexVanuatuAccount',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.vfsc,
        baseProduct: 'TradesmarterAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    TradesmarterVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'tradesmarter_vanuatu_demo',
        label: 'New Binary Options (Demo)',
        shortLabel: 'BIN',
        hasAccountFilter: 'hasTradeSmarterVanuatuDemoAccount',
        forAccountFilter: 'forTradeSmarterVanuatuDemoAccount',
        icon: 'account-type-va-tradesmarter-demo.png',
        productId: 35,
        localization: { defaultMessage: '', id: '' },
        productName: 'tradesmarter_vanuatu_demo',
        orderBy: 9,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'tradeSmarter',
        forexEquivalent: 'ForexVanuatuDemoAccount',
        isDemo: true,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.vfsc,
        baseProduct: 'TradesmarterDemoAccount',
        disallowedCurrencies: ['USDT', 'NOK', 'DKK', 'SEK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    ForexPremiumMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_premium_mauritius',
        label: 'Forex Premium MT4 Live',
        shortLabel: 'PR',
        hasAccountFilter: 'hasForexPremiumMauritiusAccount',
        forAccountFilter: 'forForexPremiumMauritiusAccount',
        icon: 'account-type-ma-forex.png',
        productId: 109,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_premium_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        subCategory: 'premium',
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['LEVERAGE'],
        termsConditionsLink: 'forexTerms',
        defaultLeverage: 1000,
        defaultAPTestLeverage: 1000,
        blockedLeveragesAfterEquityChange: [1000],
        blockedCountriesForDefaultLeverage: [{ country: 'SG', leverage: 500 }],
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexPremiumMauritiusAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        allowBonus: true,
        disallowedCountries: map(pickBy(countries, (c) => !includes([
            'VN', 'TH', 'ID', 'MY', 'HK', 'CN', 'SG', 'BR', 'AR', 'MX', 'PE', 'CO', 'CL', 'EC', 'DO', 'VE', 'CR',
            'SA', 'AE', 'KW', 'MA', 'OM', 'QA', 'EG', 'TR', 'IQ', 'ZA', 'PA', 'BO', 'CU', 'UY', 'PY', 'SV', 'NI',
            'GT', 'HN', 'TW', 'IN', 'MV', 'LB',
        ], c.value)), 'value'),
        disabled: true,
    },
    ForexPremiumVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_premium_vanuatu',
        label: 'Forex Premium MT4 Live',
        shortLabel: 'PR',
        hasAccountFilter: 'hasForexPremiumVanuatuAccount',
        forAccountFilter: 'forForexPremiumVanuatuAccount',
        icon: 'account-type-va-forex.png',
        productId: 110,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_premium_vanuatu',
        orderBy: 2,
        subCategory: 'premium',
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['LEVERAGE'],
        termsConditionsLink: 'forexTerms',
        defaultLeverage: 1000,
        defaultAPTestLeverage: 1000,
        blockedLeveragesAfterEquityChange: [1000],
        blockedCountriesForDefaultLeverage: [{ country: 'SG', leverage: 500 }],
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexPremiumMauritiusAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        additionalCountryCurrencies: [{ accountSubtype: 'LEVERAGE', country: 'ZA', currencies: ['ZAR'] }],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        allowBonus: true,
        disallowedCountries: map(pickBy(countries, (c) => !includes([
            'VN', 'TH', 'ID', 'MY', 'HK', 'CN', 'SG', 'BR', 'AR', 'MX', 'PE', 'CO', 'CL', 'EC', 'DO', 'VE', 'CR',
            'SA', 'AE', 'KW', 'MA', 'OM', 'QA', 'EG', 'TR', 'IQ', 'ZA', 'PA', 'BO', 'CU', 'UY', 'PY', 'SV', 'NI',
            'GT', 'HN', 'TW', 'IN', 'MV', 'LB',
        ], c.value)), 'value'),
        disabled: true,
    },
    PAMMMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'pamm_mauritius',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMMauritiusAccount',
        forAccountFilter: 'forPAMMMauritiusAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 36,
        localization: { defaultMessage: '', id: '' },
        productName: 'pamm_mauritius',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
        manuallyAllowed: false,
        kycRequired: true,
        clientPermittedByCountry: true,
        clientMaxAllowed: 1,
    },
    PAMMFundManagerMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'pammFundManager_mauritius',
        label: 'Fund Manager Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMFundManagerMauritiusAccount',
        forAccountFilter: 'forPAMMFundManagerMauritiusAccount',
        icon: 'account-type-ma-pamm-fm.png',
        productId: 17,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammFundManager_mauritius',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    AffiliateMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'affiliate_mauritius',
        label: 'Affiliate - Cellxperts',
        shortLabel: 'AFF',
        hasAccountFilter: 'hasAffiliateMauritiusAccount',
        forAccountFilter: 'forAffiliateMauritiusAccount',
        icon: 'account-type-ma-cellxpert.png',
        productId: 37,
        localization: { defaultMessage: '', id: '' },
        productName: 'affiliate_mauritius',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: true,
        category: 'affiliate',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.fsc,
        baseProduct: 'AffiliateAccount',
        walletProduct: true,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'EUR', 'GBP', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        supportsMultipleAccounts: true,
    },
    IntroducingBrokerSwissMarketsAccount: {
        company: companies.swissMarkets.value,
        value: 'introducingBrokerSwissMarkets',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerSwissMarketsAccount',
        forAccountFilter: 'forIntroducingBrokerSwissMarketsAccount',
        icon: 'account-type-sm-ib.png',
        productId: 38,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBrokerSwissMarkets',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerSwissMarketsAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
    },
    IntroducingBrokerAccount: {
        company: companies.bdSwiss.value,
        value: 'introducingBroker',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerAccount',
        forAccountFilter: 'forIntroducingBrokerAccount',
        icon: 'account-type-bd-ib.png',
        productId: 39,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBroker',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
    },
    IntroducingBrokerSwissMarketsMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'introducingBrokerSwissMarkets_mauritius',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerSwissMarketsMauritiusAccount',
        forAccountFilter: 'forIntroducingBrokerSwissMarketsMauritiusAccount',
        icon: 'account-type-sm-ma-ib.png',
        productId: 40,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBrokerSwissMarkets_mauritius',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerSwissMarketsAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
    },
    IntroducingBrokerMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'introducingBroker_mauritius',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerAccount',
        forAccountFilter: 'forIntroducingBrokerAccount',
        icon: 'account-type-bd-ma-ib.png',
        productId: 41,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBroker_mauritius',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
    },
    ForexClassicMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'forex_classic_mauritius',
        label: 'STP',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicMauritiusAccount',
        forAccountFilter: 'forForexClassicMauritiusAccount',
        icon: 'account-type-sm-ma-forex-classic.jpg',
        productId: 42,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic_mauritius',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['CLASSIC'],
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexClassicAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    ForexClassicMauritiusDemoAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'forex_classic_mauritius_demo',
        label: 'STP Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicMauritiusDemoAccount',
        forAccountFilter: 'forForexClassicMauritiusDemoAccount',
        icon: 'account-type-sm-ma-forex-classic-demo.jpg',
        productId: 43,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexClassicDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        openSeperateDemo: true,
        deprecated: false,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    ForexRawMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'forex_raw_mauritius',
        label: 'STP Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawMauritiusAccount',
        forAccountFilter: 'forForexRawMauritiusAccount',
        icon: 'account-type-sm-ma-forex-raw.jpg',
        productId: 44,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['SWISS11', 'SWISS4'],
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexRawAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    PAMMSMMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'pammSm_mauritius',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMSMMauritiusAccount',
        forAccountFilter: 'forPAMMSMMauritiusAccount',
        icon: 'account-type-sm-ma-pamm.jpg',
        productId: 45,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammSm_mauritius',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMSMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
    },
    PAMMSMFundManagerMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'pammSmFundManager_mauritius',
        label: 'Fund Manager Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMFundManagerMauritiusAccount',
        forAccountFilter: 'forPAMMFundManagerMauritiusAccount',
        icon: 'account-type-sm-ma-pamm-fm.jpg',
        productId: 46,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammSmFundManager_mauritius',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMSMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    AIPAMMAccount: {
        company: companies.bdSwiss.value,
        value: 'ai_forex',
        label: 'AI Portfolio Management',
        shortLabel: 'AI',
        hasAccountFilter: 'hasAIPAMMAccount',
        forAccountFilter: 'forAIPAMMAccount',
        icon: 'account-type-bd-pamm.png',
        productId: 47,
        localization: { defaultMessage: '', id: '' },
        productName: 'ai_forex',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4Ai',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'AIPAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    AIPAMMMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'ai_forex_mauritius',
        label: 'AI Portfolio Management',
        shortLabel: 'AI',
        hasAccountFilter: 'hasAIPAMMMauritiusAccount',
        forAccountFilter: 'forAIPAMMMauritiusAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 48,
        localization: { defaultMessage: '', id: '' },
        productName: 'ai_forex_mauritius',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4Ai',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'AIPAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    AIPAMMDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'ai_forex_demo',
        label: 'AI Demo Portfolio Management',
        shortLabel: 'AI',
        hasAccountFilter: 'hasAIPAMMDemoAccount',
        forAccountFilter: 'forAIPAMMDemoAccount',
        icon: 'account-type-bd-pamm.png',
        productId: 49,
        localization: { defaultMessage: '', id: '' },
        productName: 'ai_forex_demo',
        orderBy: 5,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4Ai',
        isDemo: true,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [1000],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'AIPAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    AIPAMMMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'ai_forex_mauritius_demo',
        label: 'AI Demo Portfolio Management',
        shortLabel: 'AI',
        hasAccountFilter: 'hasAIPAMMMauritiusDemoAccount',
        forAccountFilter: 'forAIPAMMMauritiusDemoAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 50,
        localization: { defaultMessage: '', id: '' },
        productName: 'ai_forex_mauritius_demo',
        orderBy: 5,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4Ai',
        isDemo: true,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [1000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'AIPAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BDXcoin: {
        company: companies.bdxAccounts.value,
        value: 'bdxcoin',
        label: 'Tokens for BDXCoin',
        shortLabel: 'BDX',
        hasAccountFilter: 'hasBDXCoinAccount',
        forAccountFilter: 'forBDXCoinAccount',
        icon: 'account-type-bdxcoin.png',
        productId: 51,
        localization: { defaultMessage: '', id: '' },
        productName: 'bdxcoin',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cryptocoin',
        prefix: 'bdxcoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'BDXcoin',
        baseCurrency: 'EUR',
        allowBonus: true,
        deleted: false,
        deprecated: true,
    },
    BDXcoinMauritius: {
        company: companies.bdSwissMauritius.value,
        value: 'bdxcoin_mauritius',
        label: 'BDXcoin',
        shortLabel: 'BDX',
        hasAccountFilter: 'hasBDXCoinMauritiusAccount',
        forAccountFilter: 'forBDXCoinMauritiusAccount',
        icon: 'account-type-bdxcoin.png',
        productId: 52,
        localization: { defaultMessage: '', id: '' },
        productName: 'bdxcoin_mauritius',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cryptocoin',
        prefix: 'bdxcoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'BDXcoin',
        baseCurrency: 'EUR',
        disabled: true,
        hideFromUsers: true,
        deleted: false,
        deprecated: true,
    },
    IntroducingBrokerSwissMarketsVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'introducingBrokerSwissMarkets_vanuatu',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerSwissMarketsVanuatuAccount',
        forAccountFilter: 'forIntroducingBrokerSwissMarketsVanuatuAccount',
        icon: 'account-type-sm-va-ib.png',
        productId: 53,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBrokerSwissMarkets_vanuatu',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerSwissMarketsAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
    },
    ForexClassicVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'forex_classic_vanuatu',
        label: 'STP',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicVanuatuAccount',
        forAccountFilter: 'forForexClassicVanuatuAccount',
        icon: 'account-type-sm-va-forex-classic.jpg',
        productId: 54,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic_vanuatu',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['CLASSIC'],
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexClassicAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    ForexClassicVanuatuDemoAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'forex_classic_vanuatu_demo',
        label: 'STP Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexClassicVanuatuDemoAccount',
        forAccountFilter: 'forForexClassicVanuatuDemoAccount',
        icon: 'account-type-sm-va-forex-classic-demo.jpg',
        productId: 55,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_classic_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexClassicDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        openSeperateDemo: true,
        deprecated: false,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    ForexRawVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'forex_raw_vanuatu',
        label: 'STP Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawVanuatuAccount',
        forAccountFilter: 'forForexRawVanuatuAccount',
        icon: 'account-type-sm-va-forex-raw.jpg',
        productId: 56,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportedSubtypes: ['SWISS11', 'SWISS4'],
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexRawAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        deprecated: false,
        supportsDynamicLeverage: true,
    },
    PAMMSMVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'pammSm_vanuatu',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMSMVanuatuAccount',
        forAccountFilter: 'forPAMMSMVanuatuAccount',
        icon: 'account-type-sm-va-pamm.jpg',
        productId: 57,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammSm_vanuatu',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMSMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
    },
    PAMMSMFundManagerVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'pammSmFundManager_vanuatu',
        label: 'Fund Manager Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMFundManagerVanuatuAccount',
        forAccountFilter: 'forPAMMFundManagerVanuatuAccount',
        icon: 'account-type-sm-va-pamm-fm.jpg',
        productId: 58,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammSmFundManager_vanuatu',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMSMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    PAMMVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'pamm_vanuatu',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMVanuatuAccount',
        forAccountFilter: 'forPAMMVanuatuAccount',
        icon: 'account-type-va-pamm.png',
        productId: 59,
        localization: { defaultMessage: '', id: '' },
        productName: 'pamm_vanuatu',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
        manuallyAllowed: false,
        kycRequired: true,
        clientPermittedByCountry: true,
        clientMaxAllowed: 1,
    },
    PAMMFundManagerVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'pammFundManager_vanuatu',
        label: 'Fund Manager Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMFundManagerVanuatuAccount',
        forAccountFilter: 'forPAMMFundManagerVanuatuAccount',
        icon: 'account-type-va-pamm-fm.png',
        productId: 60,
        localization: { defaultMessage: '', id: '' },
        productName: 'pammFundManager_vanuatu',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        disabled: true,
        baseProduct: 'PAMMFundManagerAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    BDXcoinVanuatu: {
        company: companies.bdSwissVanuatu.value,
        value: 'bdxcoin_vanuatu',
        label: 'BDXcoin',
        shortLabel: 'BDX',
        hasAccountFilter: 'hasBDXCoinVanuatuAccount',
        forAccountFilter: 'forBDXCoinVanuatuAccount',
        icon: 'account-type-bdxcoin.png',
        productId: 61,
        localization: { defaultMessage: '', id: '' },
        productName: 'bdxcoin_vanuatu',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'cryptocoin',
        prefix: 'bdxcoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'BDXcoin',
        baseCurrency: 'EUR',
        disabled: true,
        hideFromUsers: true,
        deleted: false,
        deprecated: true,
    },
    BRFcoin: {
        company: companies.bitrace.value,
        value: 'brfcoin',
        label: 'BRFcoin',
        shortLabel: 'BRF',
        hasAccountFilter: 'hasBRFCoinAccount',
        forAccountFilter: 'forBRFCoinAccount',
        icon: 'account-type-brfcoin.png',
        productId: 62,
        localization: { defaultMessage: '', id: '' },
        productName: 'brfcoin',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cryptocoin',
        prefix: 'brfcoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'BRFcoin',
        baseCurrency: 'USD',
        deleted: false,
        deprecated: true,
    },
    AffiliateVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'affiliate_vanuatu',
        label: 'Affiliate - Cellxperts',
        shortLabel: 'AFF',
        hasAccountFilter: 'hasAffiliateVanuatuAccount',
        forAccountFilter: 'forAffiliateVanuatuAccount',
        icon: 'account-type-ma-cellxpert.png',
        productId: 37,
        localization: { defaultMessage: '', id: '' },
        productName: 'affiliate_vanuatu',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        AffiliateOpenPermitted: true,
        category: 'affiliate',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.vfsc,
        baseProduct: 'AffiliateAccount',
        walletProduct: true,
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'EUR', 'GBP', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        supportsMultipleAccounts: true,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
    IntroducingBrokerBDSwissVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'introducingBroker_vanuatu',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerAccount',
        forAccountFilter: 'forIntroducingBrokerAccount',
        icon: 'account-type-bd-ma-ib.png',
        productId: 63,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBroker_vanuatu',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
    GoldAccount: {
        company: companies.bdSwiss.value,
        value: 'gold',
        label: 'Physical Gold Account',
        shortLabel: 'GD',
        hasAccountFilter: 'hasGoldAccount',
        forAccountFilter: 'forGoldAccount',
        icon: 'account-type-gold.png',
        productId: 64,
        localization: { defaultMessage: '', id: '' },
        productName: 'gold',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'gold',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'GoldAccount',
        baseCurrency: 'EUR',
        disallowedCurrencies: disallowedGoldCurrencies,
        hidden: true,
        availableCountries: ['at', 'de', 'ch'],
        deleted: false,
        deprecated: true,
    },
    GoldMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'gold_mauritius',
        label: 'Physical Gold Account',
        shortLabel: 'GD',
        hasAccountFilter: 'hasGoldAccount',
        forAccountFilter: 'forGoldAccount',
        icon: 'account-type-gold.png',
        productId: 65,
        localization: { defaultMessage: '', id: '' },
        productName: 'gold_mauritius',
        orderBy: 2,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'gold',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'GoldAccount',
        baseCurrency: 'EUR',
        disallowedCurrencies: disallowedGoldCurrencies,
        hidden: true,
        availableCountries: ['at', 'de', 'ch'],
        deleted: false,
        deprecated: true,
    },
    GoldVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'gold_vanuatu',
        label: 'Physical Gold Account',
        shortLabel: 'GD',
        hasAccountFilter: 'hasGoldAccount',
        forAccountFilter: 'forGoldAccount',
        icon: 'account-type-gold.png',
        productId: 66,
        localization: { defaultMessage: '', id: '' },
        productName: 'gold_vanuatu',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'gold',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'GoldAccount',
        baseCurrency: 'EUR',
        disallowedCurrencies: disallowedGoldCurrencies,
        hidden: true,
        availableCountries: ['at', 'de', 'ch'],
        deleted: false,
        deprecated: true,
    },
    MAMSMMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'mam_sm_mauritius',
        label: 'MAM Account',
        shortLabel: 'MAM',
        hasAccountFilter: 'hasMAMSMMauritiusAccount',
        forAccountFilter: 'forMAMSMMauritiusAccount',
        icon: 'account-type-sm-ma-pamm.jpg',
        productId: 67,
        localization: { defaultMessage: '', id: '' },
        productName: 'mam_sm_mauritius',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'mam',
        isDemo: false,
        supportedSubtypes: ['MAM_MASTER', 'MAM_SUB'],
        supportsCustomLeverage: false,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        defaultLeverage: 200,
        supportsMultipleAccounts: true,
        baseProduct: 'MAMSMMauritiusAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        regulator: regulators.fsc,
        deleted: false,
        deprecated: false,
    },
    MAMSMVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'mam_sm_vanuatu',
        label: 'MAM Account',
        shortLabel: 'MAM',
        hasAccountFilter: 'hasMAMSMVanuatuAccount',
        forAccountFilter: 'forMAMSMVanuatuAccount',
        icon: 'account-type-sm-va-pamm.jpg',
        productId: 68,
        localization: { defaultMessage: '', id: '' },
        productName: 'mam_sm_vanuatu',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'mam',
        isDemo: false,
        supportedSubtypes: ['MAM_MASTER', 'MAM_SUB'],
        supportsCustomLeverage: false,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        defaultLeverage: 200,
        supportsMultipleAccounts: true,
        baseProduct: 'MAMSMMauritiusAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        regulator: regulators.vfsc,
        deleted: false,
        deprecated: false,
    },
    BondAccount: {
        company: companies.bdSwiss.value,
        value: 'bond',
        label: 'Bond Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondAccount',
        forAccountFilter: 'forBondAccount',
        icon: 'account-type-bd-forex.png',
        productId: 69,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: false,
        supportsCustomLeverage: false,
        server: 'VivernoMarkets-Real01',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        termsConditionsLink: 'forexTerms',
        leverages: [3],
        defaultLeverage: 3,
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'BondAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BondDemoAccount: {
        company: companies.bdSwiss.value,
        value: 'bond_demo',
        label: 'Bond Demo Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondDemoAccount',
        forAccountFilter: 'forBondDemoAccount',
        icon: 'account-type-bd-forex-demo.png',
        productId: 70,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: true,
        supportsCustomLeverage: false,
        server: 'VivernoMarkets-Demo01',
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        leverages: [1000],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'BondDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BondMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'bond_mauritius',
        label: 'Bond Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondMauritiusAccount',
        forAccountFilter: 'forBondMauritiusAccount',
        icon: 'account-type-ma-forex.png',
        productId: 71,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: false,
        supportsCustomLeverage: false,
        server: 'BDSwiss-Real01',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        termsConditionsLink: 'forexTerms',
        leverages: [3],
        defaultLeverage: 3,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'BondAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BondMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'bond_mauritius_demo',
        label: 'Bond Demo Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondMauritiusDemoAccount',
        forAccountFilter: 'forBondMauritiusDemoAccount',
        icon: 'account-type-ma-forex-demo.png',
        productId: 72,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: true,
        supportsCustomLeverage: false,
        server: 'BDSwiss-Demo01',
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        leverages: [1000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'BondDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BondVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'bond_vanuatu',
        label: 'Bond Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondVanuatuAccount',
        forAccountFilter: 'forBondVanuatuAccount',
        icon: 'account-type-va-forex.png',
        productId: 73,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: false,
        supportsCustomLeverage: false,
        server: 'BDSwiss-Real01',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        termsConditionsLink: 'forexTerms',
        leverages: [3],
        defaultLeverage: 3,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'BondAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    BondVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'bond_vanuatu_demo',
        label: 'Bond Demo Account',
        shortLabel: 'BD',
        hasAccountFilter: 'hasBondVanuatuDemoAccount',
        forAccountFilter: 'forBondVanuatuDemoAccount',
        icon: 'account-type-va-forex-demo.png',
        productId: 74,
        localization: { defaultMessage: '', id: '' },
        productName: 'bond_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        subCategory: 'bond',
        isDemo: true,
        supportsCustomLeverage: false,
        server: 'BDSwiss-Demo01',
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        leverages: [1000],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'BondDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'PLN', 'SEK', 'DKK', 'NOK', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: true,
    },
    CryptoWallet: {
        company: companies.bdSwiss.value,
        value: 'crypto_wallet',
        label: 'Crypto Wallet',
        shortLabel: 'CW',
        hasAccountFilter: 'hasCryptoWallet',
        forAccountFilter: 'forCryptoWallet',
        icon: 'account-type-bd-ma-ib.png',
        productId: 75,
        localization: { defaultMessage: '', id: '' },
        productName: 'crypto_wallet',
        orderBy: 1,
        clientCryptoTransactionPermitted: true,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cryptoWallet',
        prefix: 'cryptoWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        termsConditionsLink: 'forexTerms',
        supportsMultipleAccounts: false,
        baseProduct: 'CryptoWallet',
        deleted: false,
        deprecated: true,
    },
    FiatWallet: {
        company: companies.bdSwiss.value,
        value: 'fiat_wallet',
        label: 'EUR Wallet',
        shortLabel: 'EUR',
        hasAccountFilter: 'hasFiatWallet',
        forAccountFilter: 'forFiatWallet',
        icon: 'account-type-bd-ma-ib.png',
        productId: 76,
        localization: { defaultMessage: '', id: '' },
        productName: 'fiat_wallet',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'fiatWallet',
        prefix: 'fiatWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'FiatWallet',
        deleted: false,
        deprecated: true,
    },
    MAMMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'mam_mauritius',
        label: 'MAM Account',
        shortLabel: 'MAM',
        hasAccountFilter: 'hasMAMMauritiusAccount',
        forAccountFilter: 'forMAMMauritiusAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 77,
        localization: { defaultMessage: '', id: '' },
        productName: 'mam_mauritius',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'mam',
        isDemo: false,
        supportedSubtypes: ['MAM_MASTER', 'MAM_SUB', 'MAM_SC_SUB'],
        supportsCustomLeverage: false,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        defaultLeverage: 200,
        supportsMultipleAccounts: true,
        baseProduct: 'MAMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        regulator: regulators.fsc,
        deleted: false,
        deprecated: false,
    },
    MAMVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'mam_vanuatu',
        label: 'MAM Account',
        shortLabel: 'MAM',
        hasAccountFilter: 'hasMAMVanuatuAccount',
        forAccountFilter: 'forMAMVanuatuAccount',
        icon: 'account-type-va-pamm.png',
        productId: 78,
        localization: { defaultMessage: '', id: '' },
        productName: 'mam_vanuatu',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'mam',
        isDemo: false,
        supportedSubtypes: ['MAM_MASTER', 'MAM_SUB', 'MAM_SC_SUB'],
        supportsCustomLeverage: false,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        defaultLeverage: 200,
        supportsMultipleAccounts: true,
        baseProduct: 'MAMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        regulator: regulators.vfsc,
        deleted: false,
        deprecated: false,
    },
    MAMAccount: {
        company: companies.bdSwiss.value,
        value: 'mam',
        label: 'MAM Account',
        shortLabel: 'MAM',
        hasAccountFilter: 'hasMAMAccount',
        forAccountFilter: 'forMAMAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 79,
        localization: { defaultMessage: '', id: '' },
        productName: 'mam',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'mam',
        isDemo: false,
        supportedSubtypes: ['MAM_MASTER', 'MAM_SUB', 'MAM_SC_SUB'],
        supportsCustomLeverage: false,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        defaultLeverage: 200,
        supportsMultipleAccounts: true,
        baseProduct: 'MAMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        regulator: regulators.cysec,
        deleted: false,
        deprecated: false,
    },
    JOLLYcoin: {
        company: companies.makeYourDay.value,
        value: 'jollycoin',
        label: 'JOLLY Tokens',
        shortLabel: 'J',
        hasAccountFilter: 'hasJOLLYcoinAccount',
        forAccountFilter: 'forJOLLYcoinAccount',
        icon: 'account-type-jolly.png',
        productId: 80,
        localization: { defaultMessage: '', id: '' },
        productName: 'jollycoin',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cryptocoin',
        prefix: 'jollycoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'JOLLYcoin',
        baseCurrency: 'EUR',
        allowBonus: true,
        deleted: false,
        deprecated: true,
    },
    CLEANcoin: {
        company: companies.cleanCoinAccounts.value,
        value: 'cleancoin',
        label: 'CleanCoin Tokens',
        shortLabel: 'CL',
        hasAccountFilter: 'hasCLEANcoinAccount',
        forAccountFilter: 'forCLEANcoinAccount',
        icon: 'account-type-cleancoin.png',
        productId: 81,
        localization: { defaultMessage: '', id: '' },
        productName: 'cleancoin',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cryptocoin',
        prefix: 'cleancoin',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'CLEANcoin',
        baseCurrency: 'USD',
        allowBonus: true,
        deleted: false,
        deprecated: true,
    },
    ForexMT5Account: {
        company: companies.bdSwiss.value,
        value: 'forex_mt5',
        label: 'Forex MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5Account',
        forAccountFilter: 'forForexMT5Account',
        supportedSubtypes: ['BASIC', 'BLACK'],
        icon: 'account-type-bd-forex.png',
        productId: 82,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'VivernoMarkets-Real01',
        termsConditionsLink: 'forexTerms',
        leverages: [2, 5, 10, 20, 30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: false,
    },
    ForexMT5DemoAccount: {
        company: companies.bdSwiss.value,
        value: 'forex_mt5_demo',
        label: 'Forex MT5 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5DemoAccount',
        forAccountFilter: 'forForexMT5DemoAccount',
        icon: 'account-type-bd-forex-demo.png',
        productId: 83,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'VivernoMarkets-Demo01',
        leverages: [30],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        disallowedCountryCurrencies: [
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC', 'BLACK'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: false,
    },
    ForexMT5MauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_mt5_mauritius',
        label: 'Forex MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5MauritiusAccount',
        forAccountFilter: 'forForexMT5MauritiusAccount',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        icon: 'account-type-ma-forex.png',
        productId: 84,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    ForexMT5MauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_mt5_mauritius_demo',
        label: 'Forex MT5 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5MauritiusDemoAccount',
        forAccountFilter: 'forForexMT5MauritiusDemoAccount',
        icon: 'account-type-ma-forex-demo.png',
        productId: 85,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.demo.value,
        ],
    },
    ForexMT5VanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_mt5_vanuatu',
        label: 'Forex MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5VanuatuAccount',
        forAccountFilter: 'forForexMT5VanuatuAccount',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        icon: 'account-type-va-forex.png',
        productId: 86,
        productName: 'forex_mt5_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        localization: { defaultMessage: '', id: '' },
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        disallowedCountryCurrencies: [
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    ForexMT5VanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_mt5_vanuatu_demo',
        label: 'Forex MT5 Demo',
        hasAccountFilter: 'hasForexMT5VanuatuDemoAccount',
        forAccountFilter: 'forForexMT5VanuatuDemoAccount',
        icon: 'account-type-va-forex-demo.png',
        productId: 87,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        shortLabel: 'FX',
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP'],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
        ],
        disallowedCountryCurrencies: [
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO', 'STANDARD', 'PRO', 'PRIME'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.demo.value,
        ],
    },
    ExchangeAccount: {
        company: companies.bdSwiss.value,
        value: 'exchange',
        label: 'Exchange Account',
        shortLabel: 'EX',
        hasAccountFilter: 'hasExchangeAccount',
        forAccountFilter: 'forExchangeAccount',
        icon: 'account-type-ma-forex.png',
        productId: 88,
        localization: { defaultMessage: '', id: '' },
        productName: 'exchange',
        orderBy: 88,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'exchange',
        prefix: 'exchange',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'ExchangeAccount',
        deleted: false,
        deprecated: true,
    },
    ExchangeMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'exchange_mauritius',
        label: 'Exchange Account',
        shortLabel: 'EX',
        hasAccountFilter: 'hasExchangeMauritiusAccount',
        forAccountFilter: 'forExchangeMauritiusAccount',
        icon: 'account-type-ma-forex.png',
        productId: 89,
        localization: { defaultMessage: '', id: '' },
        productName: 'exchange_mauritius',
        orderBy: 89,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'exchange',
        prefix: 'exchange',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'ExchangeAccount',
        deleted: false,
        deprecated: true,
    },
    ExchangeVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'exchange_vanuatu',
        label: 'Exchange Account',
        shortLabel: 'EX',
        hasAccountFilter: 'hasExchangeVanuatuAccount',
        forAccountFilter: 'forExchangeVanuatuAccount',
        icon: 'account-type-va-forex.png',
        productId: 90,
        localization: { defaultMessage: '', id: '' },
        productName: 'exchange_vanuatu',
        orderBy: 90,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'exchange',
        prefix: 'exchange',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'ExchangeAccount',
        deleted: false,
        deprecated: true,
    },
    ExchangeBDXAccount: {
        company: companies.bdxAccounts.value,
        value: 'exchange_bdx',
        label: 'Exchange Account',
        shortLabel: 'EX',
        hasAccountFilter: 'hasExchangeBDXAccount',
        forAccountFilter: 'forExchangeBDXAccount',
        icon: 'account-type-bd-forex.png',
        productId: 91,
        localization: { defaultMessage: '', id: '' },
        productName: 'exchange_bdx',
        orderBy: 91,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'exchange',
        prefix: 'exchange',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: false,
        baseProduct: 'ExchangeBDXAccount',
        deleted: false,
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'CHF', 'PLN', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deprecated: true,
    },
    ForexMauritiusAccountBDX: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_mauritius_bdx',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMauritiusAccountBDX',
        forAccountFilter: 'forForexMauritiusAccountBDX',
        icon: 'account-type-ma-forex.png',
        productId: 92,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mauritius_bdx',
        orderBy: 2,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        subCategory: 'bdx',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexMauritiusAccountBDX',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
            mt4Servers.real05.value,
        ],
        deprecated: false,
    },
    ForexRawBDSwissAccount: {
        company: companies.bdSwiss.value,
        value: 'forex_raw_bdswiss',
        label: 'Forex MT4 Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawBDSwissAccount',
        forAccountFilter: 'forForexRawBDSwissAccount',
        icon: 'account-type-bdswiss-forex-raw.png',
        productId: 93,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw_bdswiss',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        subCategory: 'raw',
        isDemo: false,
        supportedSubtypes: ['RAW_TRIAL', 'RAW_GROW', 'RAW_PRO'],
        server: 'VivernoMarkets-Real01',
        supportsCustomLeverage: true,
        leverages: [2, 5, 10, 20, 30],
        supportsMultipleAccounts: false,
        regulator: regulators.cysec,
        baseProduct: 'ForexRawBDSwissAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
        ],
        subscription: true,
        deprecated: true,
        supportsDynamicLeverage: false,
    },
    ForexRawBDSwissMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_raw_bdswiss_mauritius',
        label: 'Forex MT4 Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawBDSwissMauritiusAccount',
        forAccountFilter: 'forForexRawBDSwissMauritiusAccount',
        icon: 'account-type-bdswiss-ma-forex-raw.png',
        productId: 94,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw_bdswiss_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        subCategory: 'raw',
        isDemo: false,
        supportedSubtypes: ['RAW_TRIAL', 'RAW_GROW', 'RAW_PRO'],
        server: 'BDSwiss-Real01',
        supportsCustomLeverage: true,
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'ForexRawBDSwissAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
        ],
        subscription: true,
        deprecated: true,
        supportsDynamicLeverage: true,
    },
    ForexRawBDSwissVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_raw_bdswiss_vanuatu',
        label: 'Forex MT4 Raw',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexRawBDSwissVanuatuAccount',
        forAccountFilter: 'forForexRawBDSwissVanuatuAccount',
        icon: 'account-type-bdswiss-va-forex-raw.png',
        productId: 95,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_raw_bdswiss_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        subCategory: 'raw',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['RAW_TRIAL', 'RAW_GROW', 'RAW_PRO'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexRawBDSwissAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
        ],
        subscription: true,
        deprecated: true,
        supportsDynamicLeverage: true,
    },
    SMPrimeWalletMauritiusAccount: {
        company: companies.swissMarketsMauritius.value,
        value: 'sm_prime_wallet_mauritius',
        label: 'SM Prime Wallet',
        shortLabel: 'SMP',
        hasAccountFilter: 'hasSMPrimeWalletMauritiusAccount',
        forAccountFilter: 'forSMPrimeWalletMauritiusAccount',
        icon: 'account-type-sm-ma-prime-wallet.png',
        productId: 96,
        localization: { defaultMessage: '', id: '' },
        productName: 'sm_prime_wallet_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'smPrime',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'SMPrimeWalletMauritiusAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    SMPrimeWalletBDSwissAccount: {
        company: companies.bdSwiss.value,
        value: 'sm_prime_wallet_bdswiss',
        label: 'SM Prime Wallet',
        shortLabel: 'SMP',
        hasAccountFilter: 'hasSMPrimeWalletBDSwissAccount',
        forAccountFilter: 'forSMPrimeWalletBDSwissAccount',
        icon: 'account-type-prime-wallet.png',
        productId: 97,
        localization: { defaultMessage: '', id: '' },
        productName: 'sm_prime_wallet_bdswiss',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'smPrime',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'SMPrimeWalletBDSwissAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    SMPrimeWalletBDSwissMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'sm_prime_wallet_bdswiss_mauritius',
        label: 'SM Prime Wallet',
        shortLabel: 'SMP',
        hasAccountFilter: 'hasSMPrimeWalletBDSwissMauritiusAccount',
        forAccountFilter: 'forSMPrimeWalletBDSwissMauritiusAccount',
        icon: 'account-type-ma-prime-wallet.png',
        productId: 98,
        localization: { defaultMessage: '', id: '' },
        productName: 'sm_prime_wallet_bdswiss_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'smPrime',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'SMPrimeWalletBDSwissAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    SMPrimeWalletVanuatuAccount: {
        company: companies.swissMarketsVanuatu.value,
        value: 'sm_prime_wallet_vanuatu',
        label: 'SM Prime Wallet',
        shortLabel: 'SMP',
        hasAccountFilter: 'hasSMPrimeWalletVanuatuAccount',
        forAccountFilter: 'forSMPrimeWalletVanuatuAccount',
        icon: 'account-type-sm-va-prime-wallet.png',
        productId: 99,
        localization: { defaultMessage: '', id: '' },
        productName: 'sm_prime_wallet_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'smPrime',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'SMPrimeWalletMauritiusAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    PortfolioManagementAccount: {
        company: companies.bdSwiss.value,
        value: 'portfolio_management',
        label: 'Portfolio Management Account',
        shortLabel: 'PM',
        hasAccountFilter: 'hasPAMMAccount',
        forAccountFilter: 'forPAMMAccount',
        icon: 'account-type-bd-pamm.png',
        productId: 100,
        localization: { defaultMessage: '', id: '' },
        productName: 'portfolio_management',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        subCategory: 'fundManagement',
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.cysec,
        baseProduct: 'portfolioManagementAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    PortfolioManagementMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'portfolio_management_mauritius',
        label: 'Portfolio Management Account',
        shortLabel: 'PM',
        hasAccountFilter: 'hasPAMMAccount',
        forAccountFilter: 'forPAMMAccount',
        icon: 'account-type-bd-pamm.png',
        productId: 101,
        localization: { defaultMessage: '', id: '' },
        productName: 'portfolio_management_mauritius',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        subCategory: 'fundManagement',
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'portfolioManagementAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    BitnukWalletMauritius: {
        company: companies.bdSwissMauritius.value,
        value: 'bitnuk_wallet_mauritius',
        label: 'bitwallet',
        shortLabel: 'BW',
        hasAccountFilter: 'hasBitnukWalletMauritius',
        forAccountFilter: 'forBitnukWalletMauritius',
        icon: 'account-type-ma-bitnuk-wallet.png',
        productId: 102,
        localization: { defaultMessage: '', id: '' },
        productName: 'bitnuk_wallet_mauritius',
        orderBy: 10,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'cryptoWallet',
        subCategory: 'bitnuk',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'BitnukWalletMauritius',
        disallowedCurrencies: ['USDT', 'ETH', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'EUR', 'USD', 'GBP', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    BitnukWalletVanuatu: {
        company: companies.bdSwissVanuatu.value,
        value: 'bitnuk_wallet_vanuatu',
        label: 'bitwallet',
        shortLabel: 'BW',
        hasAccountFilter: 'hasBitnukWalletVanuatu',
        forAccountFilter: 'forBitnukWalletVanuatu',
        icon: 'account-type-va-bitnuk-wallet.png',
        productId: 103,
        localization: { defaultMessage: '', id: '' },
        productName: 'bitnuk_wallet_vanuatu',
        orderBy: 10,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'cryptoWallet',
        subCategory: 'bitnuk',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'BitnukWalletMauritius',
        disallowedCurrencies: ['USDT', 'ETH', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'EUR', 'USD', 'GBP', 'CUD', 'ZAR'],
        deleted: true,
        deprecated: true,
    },
    BitnukWalletSwissMarketsMauritius: {
        company: companies.swissMarketsMauritius.value,
        value: 'bitnuk_wallet_sm_mauritius',
        label: 'bitwallet',
        shortLabel: 'BW',
        hasAccountFilter: 'hasBitnukWalletSwissMarketsMauritius',
        forAccountFilter: 'forBitnukWalletSwissMarketsMauritius',
        icon: 'account-type-sm-ma-bitnuk-wallet.png',
        productId: 104,
        localization: { defaultMessage: '', id: '' },
        productName: 'bitnuk_wallet_sm_mauritius',
        orderBy: 10,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'cryptoWallet',
        subCategory: 'bitnuk',
        isDemo: false,
        supportsCustomLeverage: false,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'BitnukWalletSwissMarketsMauritius',
        disallowedCurrencies: ['USDT', 'ETH', 'LTC', 'CHF', 'PLN', 'SEK', 'DKK', 'NOK', 'BCH', 'DASH', 'EUR', 'USD', 'GBP', 'CUD', 'ZAR'],
        deleted: false,
        deprecated: false,
    },
    CentMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'cent_mauritius',
        label: 'Cent Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMauritiusAccount',
        forAccountFilter: 'forCentMauritiusAccount',
        icon: 'account-type-ma-cent.png',
        productId: 107,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mauritius',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cent',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'CentMauritiusAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI',
            'FM', 'MS', 'MA', 'NF', 'PW', 'PN', 'SX', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TN', 'TV', 'EH',
            'CW', 'SS', 'BQ', 'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: false,
        supportsDynamicLeverage: false,
        defaultLeverage: 2000,
    },
    CentVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'cent_vanuatu',
        label: 'Cent Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentVanuatuAccount',
        forAccountFilter: 'forCentVanuatuAccount',
        icon: 'account-type-va-cent.png',
        productId: 108,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_vanuatu',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cent',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'CentMauritiusAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: false,
        supportsDynamicLeverage: false,
        defaultLeverage: 2000,
    },
    ForexSouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'forex_south_africa',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexSouthAfricaAccount',
        forAccountFilter: 'forForexSouthAfricaAccount',
        icon: 'account-type-sa-forex.png',
        productId: 113,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_south_africa',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'EUR', 'GBP'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
    },
    ForexSouthAfricaDemoAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'forex_south_africa_demo',
        label: 'Forex MT4 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexSouthAfricaDemoAccount',
        forAccountFilter: 'forForexSouthAfricaDemoAccount',
        icon: 'account-type-sa-forex-demo.png',
        productId: 114,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_south_africa_demo',
        orderBy: 2,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'EUR', 'GBP'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
    },
    ForexMT5SouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'forex_mt5_south_africa',
        label: 'Forex MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5SouthAfricaAccount',
        forAccountFilter: 'forForexMT5SouthAfricaAccount',
        supportedSubtypes: ['BASIC', 'BLACK', 'RAW', 'ZERO'],
        icon: 'account-type-sa-forex.png',
        productId: 115,
        productName: 'forex_mt5_south_africa',
        orderBy: 3,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        localization: { defaultMessage: '', id: '' },
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'EUR', 'GBP'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.Server03.serverValue,
        ],
    },
    ForexMT5SouthAfricaDemoAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'forex_mt5_south_africa_demo',
        label: 'Forex MT5 Demo',
        hasAccountFilter: 'hasForexMT5SouthAfricaDemoAccount',
        forAccountFilter: 'forForexMT5SouthAfricaDemoAccount',
        icon: 'account-type-sa-forex-demo.png',
        productId: 116,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_south_africa_demo',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        shortLabel: 'FX',
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'EUR', 'GBP'],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        mt5Servers: [
            mt5Servers.demo.value,
        ],
    },
    LdWalletAccount: {
        company: companies.bdSwiss.value,
        value: 'local_depositor_wallet',
        label: 'Payment Agent Wallet',
        shortLabel: 'LDW',
        hasAccountFilter: 'hasLdWalletAccount',
        forAccountFilter: 'forLdWalletAccount',
        icon: 'account-type-bd-ma-ib.png',
        productId: 117,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_wallet',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdWalletMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'local_depositor_wallet_mauritius',
        label: 'Payment Agent Wallet',
        shortLabel: 'LDW',
        hasAccountFilter: 'hasLdWalletMauritiusAccount',
        forAccountFilter: 'forLdWalletMauritiusAccount',
        icon: 'account-type-bd-ma-ldw.svg',
        productId: 118,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_wallet_mauritius',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdWalletComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'ldWallet_comoros',
        label: 'Local Depositor Wallet',
        shortLabel: 'LDW',
        hasAccountFilter: 'hasLdWalletComorosAccount',
        forAccountFilter: 'forLdWalletComorosAccount',
        icon: 'account-type-bd-ma-ldw.svg',
        productId: 118,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_wallet_comoros',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdWalletVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'local_depositor_wallet_vanuatu',
        label: 'Payment Agent Wallet',
        shortLabel: 'LDW',
        hasAccountFilter: 'hasLdWalletVanuatuAccount',
        forAccountFilter: 'forLdWalletVanuatuAccount',
        icon: 'account-type-bd-va-ldw.svg',
        productId: 119,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_wallet_vanuatu',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdClientWalletAccount: {
        company: companies.bdSwiss.value,
        value: 'local_depositor_client_wallet',
        label: 'Payment Agent Client Wallet',
        shortLabel: 'LDC',
        hasAccountFilter: 'hasLdClientWalletAccount',
        forAccountFilter: 'forLdClientWalletAccount',
        icon: 'account-type-bd-ma-ib.png',
        productId: 120,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_client_wallet',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorClientWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdClientWalletVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'local_depositor_client_wallet_vanuatu',
        label: 'Payment Agent Client Wallet',
        shortLabel: 'LDC',
        hasAccountFilter: 'hasLdClientWalletVanuatuAccount',
        forAccountFilter: 'forLdClientWalletVanuatuAccount',
        icon: 'account-type-bd-va-ldc.svg',
        productId: 121,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_client_wallet_vanuatu',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorClientWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdClientWalletMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'local_depositor_client_wallet_mauritius',
        label: 'Payment Agent Client Wallet',
        shortLabel: 'LDC',
        hasAccountFilter: 'hasLdClientWalletMauritiusAccount',
        forAccountFilter: 'forLdClientWalletMauritiusAccount',
        icon: 'account-type-bd-ma-ldc.svg',
        productId: 122,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_client_wallet_mauritius',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorClientWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    LdClientWalletComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'ldClientWallet_comoros',
        label: 'Local Depositor Client Wallet',
        shortLabel: 'LDC',
        hasAccountFilter: 'hasLdClientWalletComorosAccount',
        forAccountFilter: 'forLdClientWalletComorosAccount',
        icon: 'account-type-bd-ma-ldc.svg',
        productId: 122,
        localization: { defaultMessage: '', id: '' },
        productName: 'local_depositor_client_wallet_comoros',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: false,
        category: 'ldWallet',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        baseProduct: 'LocalDepositorClientWalletAccount',
        walletProduct: false,
        supportsMultipleAccounts: false,
        disallowedCurrencies: ['EUR', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH',
            'LTC', 'DASH', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        isOffline: true,
    },
    ForexComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'forex_comoros',
        label: 'Forex MT4 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexComorosAccount',
        forAccountFilter: 'forForexComorosAccount',
        icon: 'account-type-km-forex.png',
        productId: 123,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_comoros',
        orderBy: 1,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'USDT', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real03.value,
            mt4Servers.real04.value,
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
        disallowedCountryCurrencies: [
            { country: 'KE', currencies: ['ZAR'] },
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
        ],
    },
    ForexComorosDemoAccount: {
        company: companies.bdSwissComoros.value,
        value: 'forex_comoros_demo',
        label: 'Forex MT4 Demo',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexComorosDemoAccount',
        forAccountFilter: 'forForexComorosDemoAccount',
        icon: 'account-type-km-forex-demo.png',
        productId: 124,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_comoros_demo',
        orderBy: 2,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'USDT', 'ZAR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
        disallowedCountryCurrencies: [
            { country: 'KE', currencies: ['ZAR'] },
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
        ],
    },
    ForexMT5ComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'forex_mt5_comoros',
        label: 'Forex MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasForexMT5ComorosAccount',
        forAccountFilter: 'forForexMT5ComorosAccount',
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO'],
        icon: 'account-type-km-forex.png',
        productId: 125,
        productName: 'forex_mt5_comoros',
        orderBy: 3,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        localization: { defaultMessage: '', id: '' },
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'USDT', 'ZAR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        disallowedCountryCurrencies: [
            { country: 'KE', currencies: ['ZAR'] },
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        mt5Servers: [
            mt5Servers.Server02.value,
        ],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
        ],
    },
    ForexMT5ComorosDemoAccount: {
        company: companies.bdSwissComoros.value,
        value: 'forex_mt5_comoros_demo',
        label: 'Forex MT5 Demo',
        hasAccountFilter: 'hasForexMT5ComorosDemoAccount',
        forAccountFilter: 'forForexMT5ComorosDemoAccount',
        icon: 'account-type-km-forex-demo.png',
        productId: 126,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_mt5_comoros_demo',
        orderBy: 4,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        shortLabel: 'FX',
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'USDT', 'ZAR'],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC', 'BLACK', 'ZERO'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        disallowedCountryCurrencies: [
            { country: 'KE', currencies: ['ZAR'] },
            { country: 'BN', currencies: ['EUR', 'GBP'] },
            { country: 'MY', currencies: ['EUR', 'GBP'] },
            { country: 'SG', currencies: ['EUR', 'GBP'] },
        ],
        mt5Servers: [
            mt5Servers.demo.value,
        ],
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO', country: 'ZA', currencies: ['ZAR'] },
        ],
    },
    CentComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'cent_comoros',
        label: 'Cent Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentComorosAccount',
        forAccountFilter: 'forCentComorosAccount',
        icon: 'account-type-km-cent.png',
        productId: 127,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_comoros',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cent',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'CentComorosAccount',
        disallowedCurrencies: ['EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR', 'USDT'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'IQ', 'LA', 'PS', 'SY',
            'UG', 'VU', 'YE', 'BS', 'BB', 'BH', 'JO', 'KW', 'LB', 'OM', 'SA', 'SD', 'AE', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'QA', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: false,
        defaultLeverage: 2000,
    },
    IntroducingBrokerComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'introducingBroker_comoros',
        label: 'Introducing Broker Account',
        shortLabel: 'IB',
        hasAccountFilter: 'hasIntroducingBrokerComorosAccount',
        forAccountFilter: 'forIntroducingBrokerComorosAccount',
        icon: 'account-type-km-ib.png',
        productId: 128,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBroker_comoros',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
    AffiliateComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'affiliate_comoros',
        label: 'Affiliate - Cellxperts',
        shortLabel: 'AFF',
        hasAccountFilter: 'hasAffiliateComorosAccount',
        forAccountFilter: 'forAffiliateComorosAccount',
        icon: 'account-type-km-cellxpert.png',
        productId: 129,
        localization: { defaultMessage: '', id: '' },
        productName: 'affiliate_comoros',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        AffiliateOpenPermitted: true,
        category: 'affiliate',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.cfc,
        baseProduct: 'AffiliateAccount',
        walletProduct: true,
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'EUR', 'GBP', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        supportsMultipleAccounts: true,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
    CentMT5MauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'cent_mt5_mauritius',
        label: 'Cent MT5 Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5MauritiusAccount',
        forAccountFilter: 'forCentMT5MauritiusAccount',
        icon: 'account-type-ma-cent.png',
        productId: 130,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_mauritius',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'CentMT5MauritiusAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI',
            'FM', 'MS', 'MA', 'NF', 'PW', 'PN', 'SX', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TN', 'TV', 'EH',
            'CW', 'SS', 'BQ', 'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        allowBonus: false,
        supportsDynamicLeverage: false,
        defaultLeverage: 2000,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    CentMT5VanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'cent_mt5_vanuatu',
        label: 'Cent MT5 Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5VanuatuAccount',
        forAccountFilter: 'forCentMT5VanuatuAccount',
        icon: 'account-type-va-cent.png',
        productId: 131,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_vanuatu',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'CentMT5VanuatuAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        allowBonus: false,
        defaultLeverage: 2000,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    CentMT5MauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'cent_mt5_mauritius_demo',
        label: 'Cent MT5 Demo',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5MauritiusDemoAccount',
        forAccountFilter: 'forCentMT5MauritiusDemoAccount',
        icon: 'account-type-ma-cent-demo.svg',
        productId: 132,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_mauritius_demo',
        orderBy: 12,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        defaultLeverage: 2000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsc,
        baseProduct: 'CentMT5MauritiusDemoAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC_CENT'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: false,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    CentMT5VanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'cent_mt5_vanuatu_demo',
        label: 'Cent MT5 Demo',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5VanuatuDemoAccount',
        forAccountFilter: 'forCentMT5VanuatuDemoAccount',
        icon: 'account-type-va-cent-demo.svg',
        productId: 133,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_vanuatu_demo',
        orderBy: 12,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        defaultLeverage: 2000,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'CentMT5VanuatuDemoAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC_CENT'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: false,
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    CentMT5ComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'cent_mt5_comoros',
        label: 'Cent MT5 Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5ComorosAccount',
        forAccountFilter: 'forCentMT5ComorosAccount',
        icon: 'account-type-va-cent.png',
        productId: 134,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_comoros',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'CentMT5ComorosAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'IQ', 'LA', 'PS', 'SY',
            'UG', 'VU', 'YE', 'BS', 'BB', 'BH', 'JO', 'KW', 'LB', 'OM', 'SA', 'SD', 'AE', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'QA', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        allowBonus: false,
        defaultLeverage: 2000,
        supportsDynamicLeverage: false,
        mt5Servers: [
            mt5Servers.Server02.serverValue,
        ],
    },
    CentMT5ComorosDemoAccount: {
        company: companies.bdSwissComoros.value,
        value: 'cent_mt5_comoros_demo',
        label: 'Cent MT5 Demo',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5ComorosDemoAccount',
        forAccountFilter: 'forCentMT5ComorosDemoAccount',
        icon: 'account-type-va-cent-demo.svg',
        productId: 135,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_comoros_demo',
        orderBy: 12,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        defaultLeverage: 2000,
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'CentMT5ComorosDemoAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'IQ', 'LA', 'PS', 'SY',
            'UG', 'VU', 'YE', 'BS', 'BB', 'BH', 'JO', 'KW', 'LB', 'OM', 'SA', 'SD', 'AE', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'QA', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC_CENT'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: false,
        mt5Servers: [
            mt5Servers.Server02.serverValue,
        ],
    },
    ForexZuluAccountMT5Vanuatu: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_zulu_account_mt5_vanuatu',
        label: 'Forex Zulu Account MT5 Live',
        shortLabel: 'ZCT',
        hasAccountFilter: 'hasForexMT5Account',
        forAccountFilter: 'forForexMT5Account',
        supportedSubtypes: ['BLACK_ZULU', 'ZERO_ZULU', 'CENT_ZULU', 'BASIC_ZULU'],
        icon: 'account-type-bd-forex.png',
        productId: 136,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_zulu_account_mt5_vanuatu',
        orderBy: 13,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexZuluAccountMT5Vanuatu',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'EUR', 'ZAR'],
        deleted: true,
        deprecated: true,
        supportsDynamicLeverage: false,
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC_ZULU', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_ZULU', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_ZULU', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_ZULU', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_ZULU', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_ZULU', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_ZULU', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_ZULU', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_ZULU', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_ZULU', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_ZULU', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_ZULU', country: 'SZ', currencies: ['ZAR'] },
        ],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    InstitutionalVanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_institutional_vanuatu',
        label: 'Forex Institutional MT4 Live',
        shortLabel: 'INS',
        hasAccountFilter: 'hasInstitutionalVanuatuAccount',
        forAccountFilter: 'forInstitutionalVanuatuAccount',
        icon: 'account-type-va-forex.png',
        productId: 137,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real04',
        supportedSubtypes: ['INSTITUTIONAL'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
    },
    InstitutionalVanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_institutional_vanuatu_demo',
        label: 'Forex Institutional MT4 Demo',
        shortLabel: 'INS',
        hasAccountFilter: 'hasInstitutionalVanuatuDemoAccount',
        forAccountFilter: 'forInstitutionalVanuatuDemoAccount',
        icon: 'account-type-va-forex-demo.png',
        productId: 138,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['INSTITUTIONAL'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
    },
    InstitutionalMT5VanuatuAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_institutional_mt5_vanuatu',
        label: 'Forex Institutional MT5 Live',
        shortLabel: 'INS',
        hasAccountFilter: 'hasInstitutionalMT5VanuatuAccount',
        forAccountFilter: 'forInstitutionalMT5VanuatuAccount',
        supportedSubtypes: ['INSTITUTIONAL'],
        icon: 'account-type-va-forex.png',
        productId: 139,
        productName: 'forex_institutional_mt5_vanuatu',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        localization: { defaultMessage: '', id: '' },
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: false,
        regulator: regulators.vfsc,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    InstitutionalMT5VanuatuDemoAccount: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_institutional_mt5_vanuatu_demo',
        label: 'Forex Institutional MT5 Demo',
        hasAccountFilter: 'hasInstitutionalMT5VanuatuDemoAccount',
        forAccountFilter: 'forInstitutionalMT5VanuatuDemoAccount',
        icon: 'account-type-va-forex-demo.png',
        productId: 140,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_mt5_vanuatu_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        shortLabel: 'INS',
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['INSTITUTIONAL'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    InstitutionalMauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_institutional_mauritius',
        label: 'Forex Institutional MT4 Live',
        shortLabel: 'INS',
        hasAccountFilter: 'hasInstitutionalMauritiusAccount',
        forAccountFilter: 'forInstitutionalMauritiusAccount',
        icon: 'account-type-ma-forex.png',
        productId: 141,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real04',
        supportedSubtypes: ['INSTITUTIONAL'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'ForexAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        deprecated: false,
        allowBonus: true,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
    },
    InstitutionalMauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_institutional_mauritius_demo',
        label: 'Forex Institutional MT4 Demo',
        shortLabel: 'INS',
        hasAccountFilter: 'hasInstitutionalMauritiusDemoAccount',
        forAccountFilter: 'forInstitutionalMauritiusDemoAccount',
        icon: 'account-type-ma-forex-demo.png',
        productId: 142,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'forexMt4',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'ForexDemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        mt4Servers: [
            mt4Servers.demo.value,
        ],
        deprecated: false,
        supportedSubtypes: ['INSTITUTIONAL'],
        openSeperateDemo: true,
        showDemoLabel: true,
        topUpMax: 1000000,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
    },
    InstitutionalMT5MauritiusAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_institutional_mt5_mauritius',
        label: 'Forex Institutional MT5 Live',
        shortLabel: 'FX',
        hasAccountFilter: 'hasInstitutionalMT5MauritiusAccount',
        forAccountFilter: 'forInstitutionalMT5MauritiusAccount',
        supportedSubtypes: ['INSTITUTIONAL'],
        icon: 'account-type-ma-forex.png',
        productId: 143,
        productName: 'forex_institutional_mt5_mauritius',
        orderBy: 2,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        localization: { defaultMessage: '', id: '' },
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400],
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'ForexMT5Account',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    InstitutionalMT5MauritiusDemoAccount: {
        company: companies.bdSwissMauritius.value,
        value: 'forex_institutional_mt5_mauritius_demo',
        label: 'Forex Institutional MT5 Demo',
        hasAccountFilter: 'hasInstitutionalMT5MauritiusDemoAccount',
        forAccountFilter: 'forInstitutionalMT5MauritiusDemoAccount',
        icon: 'account-type-ma-forex-demo.png',
        productId: 144,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_institutional_mt5_mauritius_demo',
        orderBy: 3,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: false,
        category: 'forexMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        shortLabel: 'INS',
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000],
        defaultLeverage: 1000,
        supportsMultipleAccounts: false,
        regulator: regulators.fsc,
        baseProduct: 'ForexMT5DemoAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'GBP', 'EUR'],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['INSTITUTIONAL'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: true,
        availableCountries: ['bh', 'eg', 'iq', 'il', 'jo', 'kw', 'lb', 'om', 'qa', 'sa', 'ae', 'ye', 'ps'],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    PAMMComorosAccount: {
        company: companies.bdSwissComoros.value,
        value: 'pamm_comoros',
        label: 'Managed Account',
        shortLabel: 'PAM',
        hasAccountFilter: 'hasPAMMComorosAccount',
        forAccountFilter: 'forPAMMComorosAccount',
        icon: 'account-type-ma-pamm.png',
        productId: 145,
        localization: { defaultMessage: '', id: '' },
        productName: 'pamm_comoros',
        orderBy: 4,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        category: 'pammForex',
        isDemo: false,
        supportsCustomLeverage: true,
        termsConditionsLink: 'forexTerms',
        leverages: [],
        supportsMultipleAccounts: true,
        baseProduct: 'PAMMAccount',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR'],
        deleted: false,
        disallowedCountries: ['AT', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT',
            'RO', 'SK', 'SI', 'ES', 'SE', 'NL', 'GB', 'CH'],
        deprecated: false,
        manuallyAllowed: false,
        kycRequired: true,
        clientPermittedByCountry: true,
        clientMaxAllowed: 1,
    },
    ForexCopyTradingAccountMT5Vanuatu: {
        company: companies.bdSwissVanuatu.value,
        value: 'forex_copy_trading_account_mt5_vanuatu',
        label: 'Forex Copy Trading Account MT5 Live',
        shortLabel: 'CPT',
        hasAccountFilter: 'hasForexMT5Account',
        forAccountFilter: 'forForexMT5Account',
        supportedSubtypes: ['BASIC_COPY_FW', 'ZERO_COPY_FW', 'CENT_COPY_FW', 'BLACK_COPY_FW', 'BASIC_COPY_PR', 'ZERO_COPY_PR', 'CENT_COPY_PR', 'BLACK_COPY_PR'],
        icon: 'account-type-bd-forex.png',
        productId: 146,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_copy_trading_account_mt5_vanuatu',
        orderBy: 13,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.vfsc,
        baseProduct: 'ForexCopyTradingAccountMT5Vanuatu',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'EUR', 'ZAR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: false,
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
        ],
        mt5Servers: [
            mt5Servers.Server01.serverValue,
        ],
    },
    ForexCopyTradingAccountMT5Comoros: {
        company: companies.bdSwissComoros.value,
        value: 'forex_copy_trading_account_mt5_comoros',
        label: 'Forex Copy Trading Account MT5 Live',
        shortLabel: 'CPT',
        hasAccountFilter: 'hasForexMT5Account',
        forAccountFilter: 'forForexMT5Account',
        supportedSubtypes: ['BASIC_COPY_FW', 'ZERO_COPY_FW', 'CENT_COPY_FW', 'BLACK_COPY_FW', 'BASIC_COPY_PR', 'ZERO_COPY_PR', 'CENT_COPY_PR', 'BLACK_COPY_PR'],
        icon: 'account-type-bd-forex.png',
        productId: 147,
        localization: { defaultMessage: '', id: '' },
        productName: 'forex_copy_trading_account_mt5_comoros',
        orderBy: 13,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500],
        supportsMultipleAccounts: true,
        regulator: regulators.cfc,
        baseProduct: 'ForexCopyTradingAccountMT5Comoros',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'GBP', 'EUR', 'ZAR'],
        deleted: false,
        deprecated: false,
        supportsDynamicLeverage: false,
        additionalCountryCurrencies: [
            { accountSubtype: 'BASIC_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_FW', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BASIC_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'BLACK_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'ZA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'LS', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'NA', currencies: ['ZAR'] },
            { accountSubtype: 'ZERO_COPY_PR', country: 'SZ', currencies: ['ZAR'] },
        ],
        mt5Servers: [
            mt5Servers.Server02.serverValue,
        ],
    },
    CentMT5SouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'cent_mt5_south_africa',
        label: 'Cent MT5 Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5SouthAfricaAccount',
        forAccountFilter: 'forCentMT5SouthAfricaAccount',
        icon: 'account-type-sa-cent.png',
        productId: 148,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_south_africa',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real01',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'CentMT5SouthAfricaAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        allowBonus: false,
        defaultLeverage: 2000,
        mt5Servers: [
            mt5Servers.Server03.serverValue,
        ],
    },
    CentMT5SouthAfricaDemoAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'cent_mt5_south_africa_demo',
        label: 'Cent MT5 Demo',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentMT5SouthAfricaDemoAccount',
        forAccountFilter: 'forCentMT5SouthAfricaDemoAccount',
        icon: 'account-type-sa-cent-demo.svg',
        productId: 149,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_mt5_south_africa_demo',
        orderBy: 12,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: false,
        clientOpenPermitted: true,
        category: 'centMt5',
        isDemo: true,
        supportsCustomLeverage: true,
        server: 'BDSwiss-Demo01',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        defaultLeverage: 2000,
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'CentMT5SouthAfricaDemoAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        deprecated: false,
        topUpMax: 1000000,
        supportedSubtypes: ['BASIC_CENT'],
        openSeperateDemo: true,
        showDemoLabel: true,
        supportsDynamicLeverage: false,
        mt5Servers: [
            mt5Servers.Server03.serverValue,
        ],
    },
    CentSouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'cent_south_africa',
        label: 'Cent Account',
        shortLabel: 'CUD',
        hasAccountFilter: 'hasCentSouthAfricaAccount',
        forAccountFilter: 'forCentSouthAfricaAccount',
        icon: 'account-type-sa-cent.png',
        productId: 150,
        localization: { defaultMessage: '', id: '' },
        productName: 'cent_south_africa',
        orderBy: 11,
        clientDepositPermitted: true,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'cent',
        isDemo: false,
        supportsCustomLeverage: true,
        server: 'BDSwissGlobal-Real05',
        supportedSubtypes: ['BASIC_CENT'],
        termsConditionsLink: 'forexTerms',
        leverages: [10, 50, 100, 200, 300, 400, 500, 1000, 2000],
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        baseProduct: 'CentSouthAfricaAccount',
        disallowedCurrencies: ['USDT', 'EUR', 'USD', 'GBP', 'PLN', 'CHF', 'SEK', 'DKK', 'NOK', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'ZAR'],
        disallowedCountries: [
            'AQ', 'KP', 'VG', 'WF', 'MU', 'SC', 'CA', 'LS', 'NZ', 'US', 'AF', 'BA', 'ET', 'IR', 'LA', 'SY',
            'UG', 'VU', 'BS', 'BB', 'SD', 'AX', 'AL', 'AD', 'FO',
            'GI', 'GL', 'IS', 'IM', 'XK', 'LI', 'MK', 'MC', 'ME', 'NO', 'RS', 'SJ', 'CH', 'GB', 'CG',
            'ER', 'SO', 'JP', 'AU', 'DZ', 'BT', 'BV', 'CX', 'CC', 'CK', 'DJ', 'FK', 'GY', 'HM', 'VA', 'KI', 'FM',
            'MS', 'NF', 'PW', 'PN', 'PM', 'ST', 'GS', 'TJ', 'TL', 'TK', 'TO', 'TV', 'EH', 'CW', 'SX', 'SS', 'BQ',
            'BY', 'KZ', 'RU', 'UA',
            ...map(filter(countries, (c) => !!c.isEU), 'value'),
        ],
        deleted: false,
        mt4Servers: [
            mt4Servers.real05.value,
        ],
        deprecated: false,
        allowBonus: false,
        supportsDynamicLeverage: false,
        defaultLeverage: 2000,
    },
    IntroducingBrokerSouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'introducingBroker_south_africa',
        label: 'Partner Wallet',
        shortLabel: 'PW',
        hasAccountFilter: 'hasIntroducingBrokerAccount',
        forAccountFilter: 'forIntroducingBrokerAccount',
        icon: 'account-type-sa-ib.png',
        productId: 151,
        localization: { defaultMessage: '', id: '' },
        productName: 'introducingBroker_south_africa',
        orderBy: 5,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: true,
        category: 'forexMt4',
        isDemo: false,
        supportsCustomLeverage: false,
        leverages: [],
        supportsMultipleAccounts: true,
        regulator: regulators.fsca,
        disabled: false,
        hidden: true,
        baseProduct: 'IntroducingBrokerAccount',
        walletProduct: true,
        subCategory: 'ib',
        disallowedCurrencies: ['USDT', 'ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT', 'GBP'],
        deleted: false,
        deprecated: false,
        clientMaxAllowed: 1,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
    AffiliateSouthAfricaAccount: {
        company: companies.bdSwissSouthAfrica.value,
        value: 'affiliate_south_africa',
        label: 'Partner Wallet - CX',
        shortLabel: 'AFF',
        hasAccountFilter: 'hasAffiliateSouthAfricaAccount',
        forAccountFilter: 'forAffiliateSouthAfricaAccount',
        icon: 'account-type-sa-cellxpert.png',
        productId: 152,
        localization: { defaultMessage: '', id: '' },
        productName: 'affiliate_south_africa',
        orderBy: 1,
        clientDepositPermitted: false,
        clientWithdrawalPermitted: true,
        clientOpenPermitted: false,
        AffiliateOpenPermitted: true,
        category: 'affiliate',
        isDemo: false,
        supportsCustomLeverage: false,
        disabled: false,
        regulator: regulators.cfc,
        baseProduct: 'AffiliateAccount',
        walletProduct: true,
        disallowedCurrencies: ['ETH', 'BTC', 'BCH', 'LTC', 'DASH', 'SEK', 'DKK', 'NOK', 'EUR', 'GBP', 'PLN', 'CHF', 'CUD', 'ZAR', 'USDT'],
        deleted: false,
        deprecated: false,
        supportsMultipleAccounts: true,
        disallowedCountries: ['IR', 'MM', 'SY', 'KP'],
    },
}));
export const accountSubtypes = generateLocalization('accountSubtypes', generateKeys({
    institutional: {
        value: 'INSTITUTIONAL',
        label: 'Institutional',
        shortLabel: 'INS',
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
        },
        mt4CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissMauritius.key]: [mt4Servers.real04.value],
        },
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        allowedPartialDeposits: true,
    },
    standard: {
        value: 'STANDARD',
        label: 'Standard',
        localization: { defaultMessage: '', id: '' },
        activationFtd: 100,
        disallowedCountries: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
        },
        mt4CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissMauritius.key]: [mt4Servers.real04.value],
        },
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        maxAllowed: 2,
        disallowedCurrencies: ['GBP', 'EUR'],
        clientOpenPermittedDemo: true,
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
    },
    pro: {
        value: 'PRO',
        label: 'Pro',
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
        },
        mt4CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissMauritius.key]: [mt4Servers.real04.value],
        },
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        maxAllowed: 2,
        disallowedCurrencies: ['GBP', 'EUR'],
        clientOpenPermittedDemo: true,
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
        allowedPartialDeposits: true,
    },
    prime: {
        value: 'PRIME',
        label: 'Prime',
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
        },
        mt4Servers: [
            mt4Servers.real04.value,
        ],
        mt4CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissMauritius.key]: [mt4Servers.real04.value],
        },
        maxAllowed: 2,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
        disallowedCurrencies: ['GBP', 'EUR'],
        clientOpenPermittedDemo: true,
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
        allowedPartialDeposits: true,
    },
    basic: {
        value: 'BASIC',
        label: 'Classic',
        maxAllowed: 3,
        shortLabel: 'CLS',
        allowBonus: true,
        clientOpenPermittedDemo: true,
        skipFundRestriction: true,
        educationalVideosLevel: educationalVideoLevels.beginner.value,
        localization: { defaultMessage: '', id: '' },
        mt4CompanyServers: {
            [companies.bdSwissComoros.key]: [mt4Servers.real05.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real05.value],
            [companies.bdSwissMauritius.key]: [mt4Servers.real05.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real05.value],
        },
        mt4CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt4Servers.real03.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real03.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real03.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real03.value],
        },
        mt4CompanyServersDynamicAsia1: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real04.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real04.value],
        },
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        mt5CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        maxAllowedLeverage: (isDynamic) => isDynamic ? 2000 : 0,
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
        specialGroup: (country, isDynamic, isDemo) => {
            if (isDynamic && specialGroupChecker.isDynamicAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.basicDynamic,
                    [companies.bdSwissVanuatu.value]: isDemo ? specialSubtypeGroups.basicDynamic : specialSubtypeGroups.basicDynamicAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? specialSubtypeGroups.basicDynamic : specialSubtypeGroups.basicDynamicAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? specialSubtypeGroups.basicDynamic : specialSubtypeGroups.basicDynamicAsia1,
                };
            }
            else if (isDynamic && specialGroupChecker.isDynamicGroup(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.basicDynamic,
                    [companies.bdSwissVanuatu.value]: specialSubtypeGroups.basicDynamic,
                    [companies.bdSwissComoros.value]: specialSubtypeGroups.basicDynamic,
                    [companies.bdSwissSouthAfrica.value]: specialSubtypeGroups.basicDynamic,
                };
            }
            else if (specialGroupChecker.isAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: null,
                    [companies.bdSwissVanuatu.value]: isDemo ? null : specialSubtypeGroups.basicAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? null : specialSubtypeGroups.basicAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? null : specialSubtypeGroups.basicAsia1,
                };
            }
            else {
                return null;
            }
        },
        clientOpenAllowedDashboard: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
    },
    bonus: {
        value: 'BONUS',
        label: 'Bonus',
        hideFromClients: true,
        localization: { defaultMessage: '', id: '' },
    },
    black: {
        value: 'BLACK',
        label: 'VIP',
        mt4CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt4Servers.real01.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real01.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real01.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real01.value],
        },
        mt4CompanyServersDynamicAsia1: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real04.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real04.value],
        },
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        mt5CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        maxAllowed: 1,
        shortLabel: 'VIP',
        allowedPartialDeposits: true,
        educationalVideosLevel: educationalVideoLevels.intermediate.value,
        localization: { defaultMessage: '', id: '' },
        disallowedCurrencies: ['GBP'],
        additionalCountryCurrencies: [
            ...map(filter(countries, (country) => includes(regions.mena.countries, country)), (country) => {
                return {
                    country: country.value,
                    currencies: ['GBP'],
                };
            }),
        ],
        maxAllowedLeverage: (isDynamic) => isDynamic ? 2000 : 0,
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
        specialGroup: (country, isDynamic, isDemo) => {
            if (isDynamic && specialGroupChecker.isDynamicAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.blackDynamic,
                    [companies.bdSwissVanuatu.value]: isDemo ? specialSubtypeGroups.blackDynamic : specialSubtypeGroups.blackDynamicAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? specialSubtypeGroups.blackDynamic : specialSubtypeGroups.blackDynamicAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? specialSubtypeGroups.blackDynamic : specialSubtypeGroups.blackDynamicAsia1,
                };
            }
            else if (isDynamic && specialGroupChecker.isDynamicGroup(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.blackDynamic,
                    [companies.bdSwissVanuatu.value]: specialSubtypeGroups.blackDynamic,
                    [companies.bdSwissComoros.value]: specialSubtypeGroups.blackDynamic,
                    [companies.bdSwissSouthAfrica.value]: specialSubtypeGroups.blackDynamic,
                };
            }
            else if (specialGroupChecker.isAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: null,
                    [companies.bdSwissVanuatu.value]: isDemo ? null : specialSubtypeGroups.blackAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? null : specialSubtypeGroups.blackAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? null : specialSubtypeGroups.blackAsia1,
                };
            }
            else {
                return null;
            }
        },
        clientOpenAllowedDashboard: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
    },
    swiss5: {
        value: 'SWISS5',
        label: 'Swiss 5',
        localization: { defaultMessage: '', id: '' },
    },
    swiss8: {
        value: 'SWISS8',
        label: 'Swiss 8',
        localization: { defaultMessage: '', id: '' },
    },
    swiss11: {
        value: 'SWISS11',
        label: 'Swiss 11',
        localization: { defaultMessage: '', id: '' },
    },
    classic: {
        value: 'CLASSIC',
        label: 'Classic',
        localization: { defaultMessage: '', id: '' },
    },
    swiss4: {
        value: 'SWISS4',
        label: 'Swiss 0',
        hideFromClients: true,
        localization: { defaultMessage: '', id: '' },
    },
    ib_wallet: {
        value: 'IB_WALLET',
        label: 'Ib Wallet',
        localization: { defaultMessage: '', id: '' },
    },
    ld_wallet: {
        value: 'LD_WALLET',
        label: 'Payment Agent Wallet',
        maxAllowed: 1,
        ldWalletAccountType: true,
        localization: { defaultMessage: '', id: '' },
    },
    ld_client_wallet: {
        value: 'LD_CLIENT_WALLET',
        label: 'Payment Agent Client Wallet',
        maxAllowed: 1,
        ldClientWalletAccountType: true,
        localization: { defaultMessage: '', id: '' },
    },
    ai: {
        value: 'AI',
        label: 'AI',
        localization: { defaultMessage: '', id: '' },
    },
    master: {
        value: 'MAM_MASTER',
        label: 'Master',
        localization: { defaultMessage: '', id: '' },
    },
    sub: {
        value: 'MAM_SUB',
        label: 'Sub',
        localization: { defaultMessage: '', id: '' },
    },
    sc_sub: {
        value: 'MAM_SC_SUB',
        label: 'Daily Interest Managed Account',
        localization: { defaultMessage: '', id: '' },
    },
    bonds: {
        value: 'BONDS',
        label: 'Bonds',
        localization: { defaultMessage: '', id: '' },
    },
    aff001: {
        value: 'AFF01',
        label: 'Affiliate Special Group 1',
        hideFromClients: true,
        affiliateAccountType: true,
        localization: { defaultMessage: '', id: '' },
    },
    aff002: {
        value: 'AFF02',
        label: 'Affiliate Special Group 2 [2 Pips MU]',
        hideFromClients: true,
        affiliateAccountType: true,
        localization: { defaultMessage: '', id: '' },
    },
    raw_trial: {
        value: 'RAW_TRIAL',
        label: 'Trial',
        mt4Group: 'RAW_FREE',
        localization: { defaultMessage: '', id: '' },
    },
    raw_grow: {
        value: 'RAW_GROW',
        label: 'Grow',
        mt4Group: 'GROW_PRO',
        localization: { defaultMessage: '', id: '' },
    },
    raw_pro: {
        value: 'RAW_PRO',
        label: 'Pro',
        mt4Group: 'GROW_PRO',
        localization: { defaultMessage: '', id: '' },
    },
    raw: {
        value: 'RAW',
        label: 'Raw',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        mt4CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt4Servers.real05.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real05.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real05.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real05.value],
            [companies.swissMarketsMauritius.key]: [mt4Servers.real05.value],
            [companies.swissMarketsVanuatu.key]: [mt4Servers.real05.value],
        },
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        maxAllowed: 1,
        shortLabel: 'RAW',
        allowedPartialDeposits: true,
        educationalVideosLevel: educationalVideoLevels.advanced.value,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
        clientOpenAllowedDashboard: map(filter(countries, (country) => !includes(regions.mena.countries, country)), 'value'),
    },
    invest_plus: {
        value: 'INVEST_PLUS',
        label: 'StockPlus',
        maxAllowed: 1,
        shortLabel: 'STP',
        allowedPartialDeposits: false,
        defaultLeverage: 5,
        maxAllowedLeverage: () => 5,
        disallowedCountries: ['VN'],
        localization: { defaultMessage: '', id: '' },
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
    },
    premium: {
        value: 'LEVERAGE',
        label: 'Premium',
        maxAllowed: 1,
        shortLabel: 'PR',
        defaultLeverage: 1000,
        allowBonus: true,
        localization: { defaultMessage: '', id: '' },
    },
    cent: {
        value: 'BASIC_CENT',
        label: 'Cent',
        maxAllowed: 1,
        shortLabel: 'CNT',
        matchesUrlParamType: (urlParamType) => ['cent', 'BASIC_CENT'].includes(urlParamType),
        associatedKey: 'BASIC_CENT',
        localization: { defaultMessage: '', id: '' },
        regionCountMinDate: { excludeRegions: ['mena'], date: '2023-10-30' },
        skipFundRestriction: true,
        mt4CompanyServersAsia1: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real05.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real05.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real05.value],
        },
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        specialGroup: (country, _, isDemo) => {
            if (specialGroupChecker.isAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: null,
                    [companies.bdSwissVanuatu.value]: isDemo ? null : specialSubtypeGroups.centAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? null : specialSubtypeGroups.centAsia1,
                };
            }
            else {
                return null;
            }
        },
        defaultLeverage: 2000,
    },
    zero: {
        value: 'ZERO',
        maxAllowed: 1,
        shortLabel: 'ZSA',
        label: 'Zero Spread',
        allowedPartialDeposits: true,
        localization: { defaultMessage: '', id: '' },
        educationalVideosLevel: educationalVideoLevels.advanced.value,
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        disallowedCurrencies: ['GBP'],
        mt4CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt4Servers.real05.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real05.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real05.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real05.value],
        },
        mt4CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt4Servers.real05.value],
            [companies.bdSwissVanuatu.key]: [mt4Servers.real05.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real05.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real05.value],
        },
        mt4CompanyServersDynamicAsia1: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real04.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real04.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real04.value],
        },
        mt4CompanyServersAsia1: {
            [companies.bdSwissVanuatu.key]: [mt4Servers.real01.value],
            [companies.bdSwissComoros.key]: [mt4Servers.real01.value],
            [companies.bdSwissSouthAfrica.key]: [mt4Servers.real01.value],
        },
        mt5CompanyServers: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        mt5CompanyServersDynamic: {
            [companies.bdSwissMauritius.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
            [companies.bdSwissSouthAfrica.key]: [mt5Servers.Server03.serverValue],
        },
        maxAllowedLeverage: (isDynamic) => isDynamic ? 2000 : 0,
        skipFundRestriction: true,
        specialGroup: (country, isDynamic, isDemo) => {
            if (isDynamic && specialGroupChecker.isDynamicAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.zeroDynamic,
                    [companies.bdSwissVanuatu.value]: isDemo ? specialSubtypeGroups.zeroDynamic : specialSubtypeGroups.zeroDynamicAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? specialSubtypeGroups.zeroDynamic : specialSubtypeGroups.zeroDynamicAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? specialSubtypeGroups.zeroDynamic : specialSubtypeGroups.zeroDynamicAsia1,
                };
            }
            else if (isDynamic && specialGroupChecker.isDynamicGroup(country)) {
                return {
                    [companies.bdSwissMauritius.value]: specialSubtypeGroups.zeroDynamic,
                    [companies.bdSwissVanuatu.value]: specialSubtypeGroups.zeroDynamic,
                    [companies.bdSwissComoros.value]: specialSubtypeGroups.zeroDynamic,
                    [companies.bdSwissSouthAfrica.value]: specialSubtypeGroups.zeroDynamic,
                };
            }
            else if (specialGroupChecker.isAsia1Group(country)) {
                return {
                    [companies.bdSwissMauritius.value]: null,
                    [companies.bdSwissVanuatu.value]: isDemo ? null : specialSubtypeGroups.zeroAsia1,
                    [companies.bdSwissComoros.value]: isDemo ? null : specialSubtypeGroups.zeroAsia1,
                    [companies.bdSwissSouthAfrica.value]: isDemo ? null : specialSubtypeGroups.zeroAsia1,
                };
            }
            else {
                return null;
            }
        },
    },
    black_zulu: {
        value: 'BLACK_ZULU',
        label: 'Zulu VIP',
        shortLabel: 'ZCT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        autogeneratedProducts: [
            { product: 'ForexMT5VanuatuAccount', subType: 'BASIC' },
            { product: 'ForexMT5VanuatuDemoAccount', subType: 'BASIC' },
        ],
        activationFtd: 125,
        minRedeposit: 50,
        disallowClientRegistration: true,
    },
    zero_zulu: {
        value: 'ZERO_ZULU',
        label: 'Zulu Zero-Spread',
        shortLabel: 'ZCT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 100,
        minRedeposit: 50,
    },
    cent_zulu: {
        value: 'CENT_ZULU',
        label: 'Zulu Cent',
        shortLabel: 'ZCT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        skipCurrencyStep: true,
        activationFtd: 25,
        minRedeposit: 10,
        defaultLeverage: 2000,
    },
    basic_zulu: {
        value: 'BASIC_ZULU',
        label: 'Zulu Classic',
        shortLabel: 'ZCT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 25,
        minRedeposit: 10,
    },
    copy_vip: {
        value: 'BLACK_COPY_FW',
        label: 'Copy VIP',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 125,
        minRedeposit: 50,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
    },
    copy_zero: {
        value: 'ZERO_COPY_FW',
        label: 'Copy Zero',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 50,
        minRedeposit: 50,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
    copy_cent: {
        value: 'CENT_COPY_FW',
        label: 'Copy Cent',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        skipCurrencyStep: true,
        activationFtd: 25,
        minRedeposit: 10,
        defaultLeverage: 2000,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
    copy_classic: {
        value: 'BASIC_COPY_FW',
        label: 'Copy Classic',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 25,
        minRedeposit: 10,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
    copy_vip_sp: {
        value: 'BLACK_COPY_PR',
        label: 'Copy VIP SP',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        autogeneratedProducts: [
            { product: 'ForexMT5VanuatuAccount', subType: 'BASIC' },
            { product: 'ForexMT5VanuatuDemoAccount', subType: 'BASIC' },
        ],
        activationFtd: 250,
        minRedeposit: 50,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
    },
    copy_zero_sp: {
        value: 'ZERO_COPY_PR',
        label: 'Copy Zero SP',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 100,
        minRedeposit: 50,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
    copy_cent_sp: {
        value: 'CENT_COPY_PR',
        label: 'Copy Cent SP',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        skipCurrencyStep: true,
        activationFtd: 100,
        minRedeposit: 10,
        defaultLeverage: 2000,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
    copy_classic_sp: {
        value: 'BASIC_COPY_PR',
        label: 'Copy Classic SP',
        shortLabel: 'CPT',
        allowedPartialDeposits: false,
        hideFromClients: false,
        maxAllowed: 1,
        localization: { defaultMessage: '', id: '' },
        disallowedCountries: map(filter(countries, (country) => includes(regions.mena.countries, country)), 'value'),
        activationFtd: 100,
        minRedeposit: 10,
        mt5CompanyServers: {
            [companies.bdSwissVanuatu.key]: [mt5Servers.Server01.serverValue],
            [companies.bdSwissComoros.key]: [mt5Servers.Server02.serverValue],
        },
        disallowClientRegistration: true,
    },
}));
export const AIGroupToggleMapping = {
    LIVE: {
        USD: {
            aiOn: 'B_BDS_AI_USD',
            aiOff: 'B_BDS_Basic_USD',
        },
        EUR: {
            aiOn: 'B_BDS_AI_EUR',
            aiOff: 'B_BDS_Basic_EUR',
        },
        GBP: {
            aiOn: 'B_BDS_AI_GBP',
            aiOff: 'B_BDS_Basic_GBP',
        },
        CHF: {
            aiOn: 'B_BDS_AI_CHF',
            aiOff: 'B_BDS_Basic_CHF',
        },
    },
    DEMO: {
        USD: {
            aiOn: 'demoBDS_AI_USD',
            aiOff: 'demoBDS_StandU',
        },
        EUR: {
            aiOn: 'demoBDS_AI_EUR',
            aiOff: 'demoBDS_StandE',
        },
        GBP: {
            aiOn: 'demoBDS_AI_GBP',
            aiOff: 'demoBscG',
        },
        CHF: {
            aiOn: 'demoBDS_AI_CHF',
            aiOff: 'demoBscC',
        },
    },
};
export const accountCategories = generateLocalization('accountCategories', generateKeys({
    forex: {
        label: 'Forex',
        accountTypeCategories: ['forexMt4', 'forexMt5', 'cent', 'centMt5'],
        localization: { defaultMessage: '', id: '' },
    },
    binary: {
        label: 'Binary',
        accountTypeCategories: ['spotOption', 'tradeSmarter'],
        localization: { defaultMessage: '', id: '' },
    },
    rangeSpreads: {
        label: 'Range Spreads',
        accountTypeCategories: ['cuboid'],
        localization: { defaultMessage: '', id: '' },
    },
    managed: {
        label: 'Managed Accounts',
        accountTypeCategories: ['pammForex', 'mam'],
        localization: { defaultMessage: '', id: '' },
    },
    affiliate: {
        label: 'Affiliate',
        accountTypeCategories: ['affiliate'],
        localization: { defaultMessage: '', id: '' },
    },
    cryptoWallet: {
        label: 'Wallets',
        accountTypeCategories: ['cryptoWallet', 'fiatWallet'],
        localization: { defaultMessage: '', id: '' },
    },
    ldWallet: {
        label: 'Payment Agent Wallet',
        accountTypeCategories: ['ldWallet', 'ldClientWallet'],
        localization: { defaultMessage: '', id: '' },
    },
}));
export const rawSubscriptionPlans = generateKeys({
    monthlyTrial: {
        value: 'monthly_trial',
        planCode: 'raw-m-trial',
        currency: 'EUR',
        defaultAmount: 1,
        label: 'Raw Trial',
        order: 1,
        isFree: false,
        vps: false,
        accountSubtype: accountSubtypes.raw_trial.key,
        minVolume: 0,
        maxVolume: 50000,
        period: 1,
        timeUnit: 'months',
        commissions: { fallBackCommission: 8, currency: 'USD' },
        features: { raw_spread: 'done', no_Commission: 'done', majors_only: 'info' },
    },
    monthlyGrow: {
        value: 'monthly_grow',
        planCode: 'raw-m-grow',
        currency: 'EUR',
        defaultAmount: 29,
        label: 'Raw Grow',
        order: 2,
        isFree: false,
        vps: false,
        accountSubtype: accountSubtypes.raw_grow.key,
        minVolume: 50000,
        maxVolume: 1000000,
        period: 1,
        timeUnit: 'months',
        commissions: { fallBackCommission: 8, currency: 'USD' },
        features: { raw_spread: 'done', no_Commission: 'done', all_pairs: 'done' },
    },
    monthlyPro: {
        value: 'monthly_pro',
        planCode: 'raw-m-pro',
        currency: 'EUR',
        defaultAmount: 79,
        label: 'Raw Pro',
        order: 3,
        isFree: false,
        vps: true,
        accountSubtype: accountSubtypes.raw_pro.key,
        minVolume: 1000000,
        maxVolume: 3000000,
        period: 1,
        timeUnit: 'months',
        commissions: { fallBackCommission: 8, overTheLimitCommission: 4, currency: 'USD' },
        features: { raw_spread: 'done', no_Commission: 'done', all_pairs: 'done', free_vps: 'done', free_historic_tick_data: 'done' },
    },
});
export const regalxAccountSubtypes = generateLocalization('regalxAccountSubtypes', generateKeys({
    basic: {
        value: 'BASIC',
        label: 'AI trading',
        maxAllowed: 3,
        shortLabel: 'AI',
        clientOpenPermittedDemo: false,
        localization: { defaultMessage: '', id: '' },
    },
    black: {
        value: 'BLACK',
        label: 'Premium',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        maxAllowed: 1,
        shortLabel: 'PR',
        allowedPartialDeposits: true,
        clientOpenPermittedDemo: false,
        localization: { defaultMessage: '', id: '' },
    },
    raw: {
        value: 'RAW',
        label: 'VIP',
        mt4Servers: [
            mt4Servers.real01.value,
        ],
        maxAllowed: 1,
        shortLabel: 'VIP',
        allowedPartialDeposits: true,
        clientOpenPermittedDemo: false,
        localization: { defaultMessage: '', id: '' },
    },
}));
export const specialSubtypeGroups = generateKeys({
    basicDynamic: {
        isDynamic: true,
        value: 'BASIC_DYNAMIC',
    },
    basicAsia1: {
        isAsia1: true,
        value: 'BASIC_ASIA1',
    },
    basicDynamicAsia1: {
        isAsia1: true,
        isDynamic: true,
        value: 'BASIC_DYNAMIC_ASIA1',
    },
    blackDynamic: {
        isDynamic: true,
        value: 'BLACK_DYNAMIC',
    },
    blackAsia1: {
        isAsia1: true,
        value: 'BLACK_ASIA1',
    },
    blackDynamicAsia1: {
        isAsia1: true,
        isDynamic: true,
        value: 'BLACK_DYNAMIC_ASIA1',
    },
    zeroDynamic: {
        isDynamic: true,
        value: 'ZERO_DYNAMIC',
    },
    zeroAsia1: {
        isAsia1: true,
        value: 'ZERO_ASIA1',
    },
    zeroDynamicAsia1: {
        isAsia1: true,
        isDynamic: true,
        value: 'ZERO_DYNAMIC_ASIA1',
    },
    centAsia1: {
        isAsia1: true,
        value: 'CENT_ASIA1',
    },
});
export function canUseDefaultCountryCurrency(country, currency, accountSubtype, type) {
    if (!find(newAccountCurrencies, { value: currency }) || !find(countries, { value: country, currency })) {
        return false;
    }
    const { disallowedCurrencies = [], additionalCountryCurrencies = [] } = type;
    const additionalCORCurrencies = get(find(additionalCountryCurrencies, { accountSubtype, country }), 'currencies', []);
    return !disallowedCurrencies.includes(currency) || additionalCORCurrencies.includes(currency);
}
const specialGroupChecker = {
    isDynamicGroup: (country) => {
        const menaCountries = map(regions.mena.countries, 'value');
        return !includes(menaCountries, country);
    },
    isAsia1Group: (country) => {
        const asia1Countries = map(filter(countries, (c) => c.asia1Group === true), 'value');
        return includes(asia1Countries, country);
    },
    isDynamicAsia1Group: (country) => {
        const menaCountries = map(regions.mena.countries, 'value');
        const asia1Countries = map(filter(countries, (c) => c.asia1Group === true), 'value');
        return !includes(menaCountries, country) && includes(asia1Countries, country);
    },
};
export const zuluLinkedStatus = generateLocalization('zuluAccountStatuses', generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    active: {
        value: 'active',
        label: 'Active',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    failed: {
        value: 'failed',
        label: 'Failed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
